import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Input, Label, Form } from 'reactstrap';
import Draggable from 'react-draggable';
import { isNumber, Storage, translate, Translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getEntitiesWithoutPending as getBanks, getEntityWithoutPending, updateEntity as updateBank } from './bank.reducer';
import { createEntity as createBankApiSetting, getEntityByBankId } from '../bank-api-setting/bank-api-setting.reducer';
import {
  createEntity,
  getBranchListByBankId,
  partialUpdateEntity,
  updateEntity,
  getEntity as getBranch,
} from 'app/entities/branch/branch.reducer';
import {
  getAccountsByBranchId,
  getUsers,
  getUsersAsAdmin,
  getUserByIdAsAdmin,
  getUserByIdAsOtherRoles,
  getUsersAsAlmoskhAdminAndStaff,
} from 'app/modules/administration/user-management/user-management.reducer';
import { AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import './bank-detail.scss';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { createTheme, responsiveFontSizes, styled, ThemeProvider, useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper, { PaperProps } from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import FormControl from '@mui/material/FormControl';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import EmailIcon from '@mui/icons-material/Email';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import {
  createEntity as createComexBankFee,
  getFeeListByBankId,
  getFeeListByBankIdAndCommodityType,
  updateEntity as updateComexBankFee,
  reset,
  deleteEntityFromBank,
} from '../comex-bank-fee/comex-bank-fee.reducer';
import { createEntity as createComexBankFeeLog } from '../comex-bank-fee-log/comex-bank-fee-log.reducer';
import { getAllEntities as getCurrencyIndexEntities } from 'app/entities/currency-index/currency-index.reducer';
import DialogTitle from '@mui/material/DialogTitle';
import { SubmitHandler, useForm } from 'react-hook-form';

import { createEntity as createCommissionLog } from 'app/entities/commission-log/commission-log.reducer';
import BankDetailFeeDeleteDialog from 'app/entities/bank/bank-detail-fee-delete-dialog';
import { BankDetailCommissionDialog } from 'app/entities/bank/bank-detail-commission-dialog';
import { BankDetailFeeDialog } from 'app/entities/bank/bank-detail-fee-dialog';
import { IBranch } from 'app/shared/model/branch.model';
import CloseIcon from '@mui/icons-material/Close';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { selectIdValue } from '@reduxjs/toolkit/dist/entities/utils';
import { Checkbox, DialogContentText, InputAdornment, Tab, Tabs } from '@mui/material';
import { formatDate } from 'app/shared/util/date-utils';
import S3 from 'react-aws-s3';
import AWS from 'aws-sdk';
import axios from 'axios';
import { getCommoditiesByBankId } from 'app/entities/commodity/commodity.reducer';
import { getAllEntities as getCurrencyRates } from 'app/entities/currency-rates/currency-rates.reducer';
import { getUserRoleAccessByUserId } from 'app/modules/administration/user-management/user-management.reducer';
import FormHelperText from '@mui/material/FormHelperText';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { enUS, ar } from 'date-fns/locale';
import TextField from '@material-ui/core/TextField';
import { BankGeneralSettingInternational, BankGeneralSettingLocal } from './bank-detail/general-setting-section';
import {DocumentSetting} from './bank-detail/document-setting-section'
import {QuotationSetting} from "app/entities/bank/bank-detail/quotation-setting-section";
import {PostPurchaseSetting} from "app/entities/bank/bank-detail/post-purchase-setting-section";
import {BookingConfirmationEmailSetting} from "app/entities/bank/bank-detail/booking-confirmation-email-setting-section";
import {CancellationSetting} from "app/entities/bank/bank-detail/cancellation-setting-section";
import {CustomerLoginSetting} from "app/entities/bank/bank-detail/customer-login-setting-section";
import {BranchSettingsWrapper} from "app/entities/bank/bank-detail/branch-settings-wrapper";
import {DocumentProvider} from "app/entities/bank/bank-detail/document-provider-section";
import {RebateFeeSetting, PERCENT_KEY as REBATE_PERCENT_KEY} from "app/entities/bank/bank-detail/rebate-fee-setting-section";

export const BankDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const account = useAppSelector(state => state.authentication.account);
  const bankEntity = useAppSelector(state => state.bank.entity);
  const bankApiSettingEntity = useAppSelector(state => state.bankApiSetting.entity);
  const commissionLog = useAppSelector(state => state.commissionLog.entity);
  const comexBankFeeList = useAppSelector(state => state.comexBankFee.entities);
  const updateSuccessBankFee = useAppSelector(state => state.comexBankFee.updateSuccess);
  const branchList = useAppSelector(state => state.branch.entities);
  const accountsByBranchId = useAppSelector(state => state.userManagement.accountsByBranchId);
  const loading = useAppSelector(state => state.comexBankFee.loading);
  const updating = useAppSelector(state => state.comexBankFee.updating);
  const userRoleAccessList = useAppSelector(state => state.userManagement.userRoleAccessList);

  const updatingBank = useAppSelector(state => state.bank.updating);
  const updateSuccessBranch = useAppSelector(state => state.branch.updateSuccess);
  const areaManager = useAppSelector(state => state.userManagement.areaManager);
  const accountsUser = useAppSelector(state => state.userManagement.accountsUser);

  const [open, setOpen] = useState(false);
  const [openBranchEdit, setOpenBranchEdit] = useState(false);
  const [openBranchCreate, setOpenBranchCreate] = useState(false);
  const [branchName, setBranchName] = useState('');
  const [branchNameInput, setBranchNameInput] = useState('');
  const [fromValue, setFromValue] = useState(1);
  const [toValue, setToValue] = useState('');
  const [oldToValue, setOldToValue] = useState('');
  const [eachAmountValue, setEachAmountValue] = useState('');
  const [oldEachAmountValue, setOldEachAmountValue] = useState('');
  const [checkedToValue, setCheckedToValue] = useState(1);
  const [checkedEachAmountValue, setCheckedEachAmountValue] = useState(1);
  const [toValueDisplayed, setToValueDisplayed] = useState('');
  const [toLimitValue, setToLimitValue] = useState(99999999999999);
  const [amount, setAmount] = useState('');
  const [checkedAmount, setCheckedAmount] = useState(1);
  const [amountDisplayed, setAmountDisplayed] = useState('');
  const [oldAmount, setOldAmount] = useState('');
  const [loadingSpinner, setLoadingSpinner] = useState(true);

  const [openDelete, setOpenDelete] = useState<number | null>(null);
  const [isNew, setIsNew] = useState(true);
  const [comexBankFeeForm, setComexBankFeeForm] = useState([] as any);
  const fullWidth = true;
  const approvalTime = bankEntity?.approvalPeriod;
  const [maxWidth, setMaxWidth] = useState<DialogProps['maxWidth']>('sm');
  const [validateFromTo, setValidateFromTo] = useState('');
  const [noDecimalAllowed, setNoDecimalAllowed] = useState(true);
  const [feeCollapse, setFeeCollapse] = React.useState(false);
  const [commoditySettingCollapse, setCommoditySettingCollapse] = React.useState(false);
  const [reportCollapse, setReportCollapse] = React.useState(false);
  const [apiSettingsCollapse, setApiSettingsCollapse] = React.useState(false);
  const [localQuotationValidityCollapse, setLocalQuotationValidityCollapse] = React.useState(false);
  const [valueSellConfirmationEndpoint, setValueSellConfirmationEndpoint] = React.useState('');
  const [valueVendorName, setValueVendorName] = React.useState('');
  const [valueVendorCif, setValueVendorCif] = React.useState('');
  const [isBranchEmpty, setIsBranchEmpty] = useState(false);
  const [isBranchExists, setIsBranchExists] = useState(false);
  const [commissionData, setCommissionData] = useState(false);
  const [commissionDataLocal, setCommissionDataLocal] = useState(false);
  const [commissionAmt, setCommissionAmt] = useState('0');
  const [checkedCommissionAmt, setCheckedCommissionAmt] = useState(0);
  const [commissionForEachAmt, setCommissionnForEachAmt] = useState('0');

  const [checkedCommissionForEachAmt, setCheckedCommissionForEachAmt] = useState(0);
  const [updateCommission, setUpdateCommission] = useState(true);
  const [updateCommissionLocal, setUpdateCommissionLocal] = useState(true);

  const [isCommissionAmountFieldClicked, setIsCommissionAmountFieldClicked] = useState(false);
  const [isCommissionForEachFieldClicked, setIsCommissionForEachFieldClicked] = useState(false);

  const [openCommission, setOpenCommission] = useState(false);
  const [openCommissionLocal, setOpenCommissionLocal] = useState(false);

  const [availableCurrency, setAvailableCurrency] = useState([]);
  const [availableCurrencyLocal, setAvailableCurrencyLocal] = useState([]);
  const [formStateFee, setFormStateFee] = useState([]);
  const [formStateFeeLocal, setFormStateFeeLocal] = useState([]);
  const [formStateCommission, setFormStateCommission] = useState([]);
  const [formStateCommissionLocal, setFormStateCommissionLocal] = useState([]);

  const [oldFormStateFee, setOldFormStateFee] = useState([]);
  const [oldFormStateFeeLocal, setOldFormStateFeeLocal] = useState([]);
  const [oldFormStateCommission, setOldFormStateCommission] = useState([]);
  const [oldFormStateCommissionLocal, setOldFormStateCommissionLocal] = useState([]);

  const [selectedCurrency, setSelectedCurrency] = useState(0);
  const [selectedCurrencyLocal, setSelectedCurrencyLocal] = useState(0);
  const [filteredComexBankFeeList, setFilteredComexBankFeeList] = useState([]);
  const [filteredComexBankFeeListLocal, setFilteredComexBankFeeListLocal] = useState([]);
  const [filteredComexBankCommissionList, setFilteredComexBankCommissionList] = useState([]);
  const [filteredComexBankCommissionListLocal, setFilteredComexBankCommissionListLocal] = useState([]);
  const [uniqueFromAmountFee, setUniqueFromAmountFee] = useState([]);
  const [uniqueFromAmountFeeLocal, setUniqueFromAmountFeeLocal] = useState([]);

  const [selectedFeeType, setSelectedFeeType] = useState('Lump Sum');
  const [selectedFeeTypeLocal, setSelectedFeeTypeLocal] = useState('Lump Sum');
  const [oldSelectedFeeType, setOldSelectedFeeType] = useState('');
  const [oldSelectedFeeTypeLocal, setOldSelectedFeeTypeLocal] = useState('');
  const [bankFeeId, setBankFeeId] = useState('');
  const [bankFeeIdLocal, setBankFeeIdLocal] = useState('');
  const [groupedData, setGroupedData] = useState([]);
  const [groupedDataLocal, setGroupedDataLocal] = useState([]);

  const [updatedFeeArray, setUpdatedFeeArray] = useState([]);
  const [updatedFeeArrayLocal, setUpdatedFeeArrayLocal] = useState([]);
  const [updatedCommissionArray, setUpdatedCommissionArray] = useState([]);
  const [updatedCommissionArrayLocal, setUpdatedCommissionArrayLocal] = useState([]);

  // Track modified currencies for multi-currency update
  const [modifiedFees, setModifiedFees] = useState(new Map());
  const [modifiedFeesLocal, setModifiedFeesLocal] = useState(new Map());
  const [modifiedCommissions, setModifiedCommissions] = useState(new Map());
  const [modifiedCommissionsLocal, setModifiedCommissionsLocal] = useState(new Map());

  const newComexBankFeeList = comexBankFeeList?.filter(c => c?.feeType !== 'commission');
  const [isPending, setIsPending] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);

  const [s3BucketName, setS3BucketName] = useState<string | null>(null);

  const [internationalCommissionDialog, setInternationalCommissionDialog] = useState({
    open: false,
    isNew: true,
    eachAmountValue: '',
    oldEachAmountValue: '',
    checkedEachAmountValue: 1,
    noDecimalAllowed: true,
  });

  const [localCommissionDialog, setLocalCommissionDialog] = useState({
    open: false,
    isNew: true,
    eachAmountValue: '',
    oldEachAmountValue: '',
    checkedEachAmountValue: 1,
    noDecimalAllowed: true,
  });

  const [internationalFeeDialog, setInternationalFeeDialog] = useState({
    open: false,
    isNew: true,
    fromValue: 1,
    toValue: '',
    oldToValue: '',
    checkedToValue: 1,
    toValueDisplayed: '',
    toLimitValue: 99999999999999,
    amount: '',
    checkedAmount: 1,
    amountDisplayed: '',
    oldAmount: '',
    bankFeeId: '',
    selectedFeeType: 'Lump Sum',
    oldSelectedFeeType: '',
    validateFromTo: '',
    noDecimalAllowed: true,
  });

  const [localFeeDialog, setLocalFeeDialog] = useState({
    open: false,
    isNew: true,
    fromValue: 1,
    toValue: '',
    oldToValue: '',
    checkedToValue: 1,
    toValueDisplayed: '',
    toLimitValue: 99999999999999,
    amount: '',
    checkedAmount: 1,
    amountDisplayed: '',
    oldAmount: '',
    bankFeeId: '',
    selectedFeeType: 'Lump Sum',
    oldSelectedFeeType: '',
    validateFromTo: '',
    noDecimalAllowed: true,
  });

  // --- helper functions (declare before use) ---
  function toEnglishDigits(str: string): string {
    if (str === null || str === undefined) return '';
    let s = String(str);
    let e = '۰'.charCodeAt(0);
    s = s.replace(/[۰-۹]/g, function (t) {
      return String(t.charCodeAt(0) - e);
    });
    e = '٠'.charCodeAt(0);
    s = s.replace(/[٠-٩]/g, function (t) {
      return String(t.charCodeAt(0) - e);
    });
    return s;
  }

  // Keeps digits and at most one decimal point, truncated to maxDecimals digits after it — used for
  // both Lump Sum and Percentage amount fields so both accept decimal input the same way.
  function sanitizeDecimalDigits(value: string, maxDecimals: number): string {
    let cleaned = String(value).replace(/[^0-9.]+/g, '');
    const firstDot = cleaned.indexOf('.');
    if (firstDot !== -1) {
      cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, '');
      cleaned = cleaned.slice(0, firstDot + 1 + maxDecimals);
    }
    return cleaned;
  }

  // Parses a (possibly comma-grouped, possibly decimal) amount string back into a number rounded to
  // 2 decimals — used right before dispatch, since formStateFee/formStateCommission amounts are kept
  // as display strings (grouped by formatGroupedAmount) rather than raw numbers.
  function parseAmountValue(value: unknown): number {
    if (value === undefined || value === null || value === '') {
      return 0;
    }
    const parsed = parseFloat(String(value).replace(/,/g, ''));
    return Number.isNaN(parsed) ? 0 : Number(parsed.toFixed(2));
  }

  // Same decimal rules as sanitizeDecimalDigits, plus thousands grouping on the integer part — used
  // by the Lump Sum amount fields, which (unlike Percentage) have always grouped digits as they're typed.
  function formatGroupedAmount(value: string, maxDecimals: number): string {
    const cleaned = sanitizeDecimalDigits(value, maxDecimals);
    const dotIndex = cleaned.indexOf('.');
    const intPart = dotIndex === -1 ? cleaned : cleaned.slice(0, dotIndex);
    const decPart = dotIndex === -1 ? undefined : cleaned.slice(dotIndex + 1);
    const formattedInt = intPart ? Number(intPart).toLocaleString() : '';
    return decPart === undefined ? formattedInt : `${formattedInt}.${decPart}`;
  }

  function filterUniqueFromAmountFeeUpdate(fromToValue) {
    // keep behavior consistent with filterUniqueFromAmountFee – recompute unique list
    filterUniqueFromAmountFee();
  }

  function filterUniqueFromAmountFeeUpdateLocal(fromToValue) {
    filterUniqueFromAmountFeeLocal();
  }

  function handleEachAmountValueInternational(e) {
    const val = toEnglishDigits(e.target.value);
    setInternationalCommissionDialog(prev => ({
      ...prev,
      eachAmountValue: val,
      checkedEachAmountValue: Number(String(val).replace(/,/g, '')) || 0,
    }));
  }

  function handleEachAmountValueLocal(e) {
    const val = toEnglishDigits(e.target.value);
    setLocalCommissionDialog(prev => ({
      ...prev,
      eachAmountValue: val,
      checkedEachAmountValue: Number(String(val).replace(/,/g, '')) || 0,
    }));
  }

  function handleToValue(e) {
    const val = toEnglishDigits(e.target.value);
    setInternationalFeeDialog(prev => ({ ...prev, toValue: val, checkedToValue: Number(String(val).replace(/,/g, '')) || 0 }));
  }

  function handleToValueLocal(e) {
    const val = toEnglishDigits(e.target.value);
    setLocalFeeDialog(prev => ({ ...prev, toValue: val, checkedToValue: Number(String(val).replace(/,/g, '')) || 0 }));
  }

  function handleAmount(e) {
    const val = toEnglishDigits(e.target.value);
    const cleaned = sanitizeDecimalDigits(val, 2);
    setInternationalFeeDialog(prev => ({ ...prev, amount: cleaned, checkedAmount: cleaned !== '' ? Number(cleaned) : 0 }));
  }

  function handleAmountLocal(e) {
    const val = toEnglishDigits(e.target.value);
    const cleaned = sanitizeDecimalDigits(val, 2);
    setLocalFeeDialog(prev => ({ ...prev, amount: cleaned, checkedAmount: cleaned !== '' ? Number(cleaned) : 0 }));
  }

  function handleFeeCollapse() {
    setFeeCollapse(prev => !prev);
  }
  function handleReportCollapse() {
    setReportCollapse(prev => !prev);
  }

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get('/api/config/bucketName');
        const bucketName = response.data.bucketName;
        setS3BucketName(bucketName);
      } catch (error) {
        console.error('Error fetching bucket name:', error);
      }
    };
    fetchConfig();
  }, []);

  useEffect(() => {
    if (account?.authorities.includes(AUTHORITIES.SUBADMIN_BANK)) {
      dispatch(getUserRoleAccessByUserId(account?.id));
    }
  }, [account]);

  useEffect(() => {
    dispatch(getEntityWithoutPending(props.match.params.id));
    dispatch(getBanks({}));
    if (account.authorities.includes(AUTHORITIES.ADMIN)) dispatch(getUsersAsAdmin({}));
    // dispatch(getUsers({}));
    else dispatch(getUsersAsAlmoskhAdminAndStaff({}));
  }, []);

  useEffect(() => {
    dispatch(getCurrencyIndexEntities({})).then(res => {
      const sortedCurrencies = [...(res?.payload['data'] || [])].sort((a, b) => a.id - b.id);
      setAvailableCurrency(sortedCurrencies);
      setAvailableCurrencyLocal(sortedCurrencies);
      const initFormState = [];
      sortedCurrencies?.forEach((item, index) => {
        initFormState.push({ amount: '', currencyId: item?.id });
      });
      setFormStateFee(initFormState);
      setFormStateFeeLocal(initFormState);
      setFormStateCommission(initFormState);
      setFormStateCommissionLocal(initFormState);
    });
  }, []);

  let selectedBranchEntity: IBranch = null;
  const {
    handleSubmit,
    register,
    reset: resetForm,
    setValue,
    formState: { errors },
  } = useForm({ mode: 'onTouched', defaultValues: comexBankFeeForm });

  useEffect(() => {
    // dispatch(getFeeListByBankId(props.match.params.id));
    if (tabIndex === 0) {
      dispatch(
        getFeeListByBankIdAndCommodityType({
          bankId: props.match.params.id,
          commodityType: 'International',
        })
      );
    } else if (tabIndex === 1) {
      dispatch(
        getFeeListByBankIdAndCommodityType({
          bankId: props.match.params.id,
          commodityType: 'Local',
        })
      );
    }
  }, [tabIndex, updateSuccessBankFee]);

  useEffect(() => {
    dispatch(getBranchListByBankId(props.match.params.id));
  }, [updateSuccessBranch]);

  useEffect(() => {
    resetForm(comexBankFeeForm);
  }, [reset, comexBankFeeForm]);

  function checkArrayDifferences(array1, array2) {
    const dict1 = {};
    const dict2 = {};

    array1?.forEach(item => {
      dict1[item?.id] = item?.amount;
    });

    array2?.forEach(item => {
      dict2[item?.id] = item?.amount;
    });

    const differences = [];
    for (const id in dict1) {
      if (Object.prototype.hasOwnProperty.call(dict2, id) && dict1[id] !== dict2[id]) {
        differences.push({ id, oldAmount: dict1[id], newAmount: dict2[id] });
      }
    }

    return differences;
  }

  const handleClickOpen = async (feeId, fromToValue) => {
    // await  dispatch(getFeeListByBankId(props.match.params.id));
    await dispatch(
      getFeeListByBankIdAndCommodityType({
        bankId: props.match.params.id,
        commodityType: 'International',
      })
    );
    const bankFeeById = comexBankFeeList?.find(fee => fee?.id === feeId && fee?.feeType !== 'commission');
    const itemIndex = availableCurrency?.findIndex(item => item?.id === feeId);

    if (feeId !== 0) {
      setInternationalFeeDialog({
        open: true,
        isNew: false,
        fromValue: internationalFeeDialog.fromValue,
        toValue: bankFeeById?.fromTo?.toLocaleString(),
        oldToValue: bankFeeById?.fromTo?.toLocaleString(),
        checkedToValue: bankFeeById?.fromTo,
        toValueDisplayed: '',
        toLimitValue: internationalFeeDialog.toLimitValue,
        amount: bankFeeById?.amount?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 4 }),
        checkedAmount: bankFeeById?.amount,
        amountDisplayed: '',
        oldAmount: bankFeeById?.amount?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 4 }),
        bankFeeId: bankFeeById?.id?.toString(),
        selectedFeeType: bankFeeById?.feeType,
        oldSelectedFeeType: bankFeeById?.feeType,
        validateFromTo: internationalFeeDialog.validateFromTo,
        noDecimalAllowed: true,
      });

      localStorage.setItem('feeAmount', bankFeeById?.fromTo?.toLocaleString());

      if (bankFeeById?.currencyId !== null) {
        const updatedFormStateFee = comexBankFeeList
          .filter(item => item.feeType === 'Lump Sum' && item.fromTo === fromToValue)
          .sort((a, b) => a.currencyId - b.currencyId)
          .map((item, index) => ({ ...item, amount: item?.amount }));

        setFormStateFee(updatedFormStateFee);

        for (let i = 0; i < groupedData.length; i++) {
          for (let j = 0; j < groupedData[i].fee.length; j++) {
            if (groupedData[i].fee[j].id === feeId) {
              setOldFormStateFee(groupedData[i].fee);
            }
          }
        }
      }
    }

    setComexBankFeeForm({});

    if (feeId === 0) {
      let newFromValue = 1;
      let newValidateFromTo = '';

      if (newComexBankFeeList?.length !== 0) {
        const maxFromTo = Math.max(...newComexBankFeeList.map(item => Number(item.fromTo))) + 1;
        newFromValue = maxFromTo;
        newValidateFromTo = `${maxFromTo} - ${bankEntity?.transactionAmountLimit}`;
      } else {
        newValidateFromTo = '1 - ' + bankEntity?.transactionAmountLimit;
      }

      const newToLimitValue = bankEntity?.transactionAmountLimit;

      setInternationalFeeDialog({
        open: true,
        isNew: true,
        fromValue: newFromValue,
        toValue: '',
        oldToValue: '',
        checkedToValue: 1,
        toValueDisplayed: '',
        toLimitValue: newToLimitValue,
        amount: '',
        checkedAmount: 1,
        amountDisplayed: '',
        oldAmount: '',
        bankFeeId: '',
        selectedFeeType: 'Lump Sum',
        oldSelectedFeeType: '',
        validateFromTo: newValidateFromTo,
        noDecimalAllowed: true,
      });
    }

    if (feeId > 0) {
      if (comexBankFeeList.length > 1) {
        filterUniqueFromAmountFeeUpdate(fromToValue);

        for (let i = 0; i < groupedData.length; i++) {
          for (let j = 0; j < groupedData[i].fee.length; j++) {
            // Iterate over each fee within the group
            if (groupedData[i].fee[j].id === feeId) {
              setComexBankFeeForm({
                ...groupedData[i].fee[j],
                fromTo: groupedData[i].fee[j].fromTo,
                amount: groupedData[i].fee[j].amount,
              });

              let newFromValue;
              let newToLimitValue;
              let newValidateFromTo;

              if (i === 0) {
                newValidateFromTo = '1 - ' + (Number(groupedData[i]?.fromTo) + 1);
                newFromValue = 1;
                newToLimitValue = groupedData?.length > 1 ? groupedData[i + 1]?.fromTo : bankEntity?.transactionAmountLimit;
              }
              if (i !== 0 && i !== groupedData.length - 1) {
                const fromToPrev = groupedData[i - 1]?.fromTo || 0;
                const fromToNext = groupedData[i + 1]?.fromTo || 0;
                newValidateFromTo = Number(fromToPrev) + 1 + ' - ' + fromToNext;
                newFromValue = fromToPrev + 1;
                newToLimitValue = fromToNext;
              }
              if (i === groupedData.length - 1) {
                const fromToPrev = groupedData[i - 1]?.fromTo || 0;
                newValidateFromTo = Number(fromToPrev) + 1 + ' - ' + bankEntity?.transactionAmountLimit;
                newFromValue = fromToPrev + 1;
                newToLimitValue = bankEntity?.transactionAmountLimit;
              }

              setInternationalFeeDialog(prev => ({
                ...prev,
                fromValue: newFromValue,
                toLimitValue: newToLimitValue,
                validateFromTo: newValidateFromTo,
              }));
            }
          }
        }
      }

      if (newComexBankFeeList?.length === 1) {
        setComexBankFeeForm({
          ...newComexBankFeeList[0],
          fromTo: newComexBankFeeList[0]?.fromTo?.toLocaleString(),
          amount: newComexBankFeeList[0]?.amount?.toLocaleString(),
        });

        setInternationalFeeDialog(prev => ({
          ...prev,
          validateFromTo: '1 - 99999999999999',
          fromValue: 1,
          toLimitValue: 9999999999999,
        }));
      }
    }

    if (!isPending) {
      setInternationalFeeDialog(prev => ({ ...prev, open: true }));
    }
  };

  const handleClickOpenLocal = async (feeId, fromToValue) => {
    // await  dispatch(getFeeListByBankId(props.match.params.id));
    await dispatch(
      getFeeListByBankIdAndCommodityType({
        bankId: props.match.params.id,
        commodityType: 'Local',
      })
    );
    const bankFeeById = comexBankFeeList?.find(fee => fee?.id === feeId && fee?.feeType !== 'commission');
    const itemIndex = availableCurrencyLocal?.findIndex(item => item?.id === feeId);

    if (feeId !== 0) {
      setLocalFeeDialog({
        open: true,
        isNew: false,
        fromValue: localFeeDialog.fromValue,
        toValue: bankFeeById?.fromTo?.toLocaleString(),
        oldToValue: bankFeeById?.fromTo?.toLocaleString(),
        checkedToValue: bankFeeById?.fromTo,
        toValueDisplayed: '',
        toLimitValue: localFeeDialog.toLimitValue,
        amount: bankFeeById?.amount?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 4 }),
        checkedAmount: bankFeeById?.amount,
        amountDisplayed: '',
        oldAmount: bankFeeById?.amount?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 4 }),
        bankFeeId: bankFeeById?.id?.toString(),
        selectedFeeType: bankFeeById?.feeType,
        oldSelectedFeeType: bankFeeById?.feeType,
        validateFromTo: localFeeDialog.validateFromTo,
        noDecimalAllowed: true,
      });

      localStorage.setItem('feeAmount', bankFeeById?.fromTo?.toLocaleString());

      if (bankFeeById?.currencyId !== null) {
        const updatedFormStateFee = comexBankFeeList
          .filter(item => item.feeType === 'Lump Sum' && item.fromTo === fromToValue)
          .sort((a, b) => a.currencyId - b.currencyId)
          .map((item, index) => ({ ...item, amount: item?.amount }));

        setFormStateFeeLocal(updatedFormStateFee);

        for (let i = 0; i < groupedDataLocal.length; i++) {
          for (let j = 0; j < groupedDataLocal[i].fee.length; j++) {
            if (groupedDataLocal[i].fee[j].id === feeId) {
              setOldFormStateFeeLocal(groupedDataLocal[i].fee);
            }
          }
        }
      }
    }

    setComexBankFeeForm({});

    if (feeId === 0) {
      let newFromValue = 1;
      let newValidateFromTo = '';

      if (newComexBankFeeList?.length !== 0) {
        const maxFromTo = Math.max(...newComexBankFeeList.map(item => Number(item.fromTo))) + 1;
        newFromValue = maxFromTo;
        newValidateFromTo = `${maxFromTo} - ${bankEntity?.transactionAmountLimit}`;
      } else {
        newValidateFromTo = '1 - ' + bankEntity?.transactionAmountLimit;
      }

      const newToLimitValue = bankEntity?.transactionAmountLimit;

      setLocalFeeDialog({
        open: true,
        isNew: true,
        fromValue: newFromValue,
        toValue: '',
        oldToValue: '',
        checkedToValue: 1,
        toValueDisplayed: '',
        toLimitValue: newToLimitValue,
        amount: '',
        checkedAmount: 1,
        amountDisplayed: '',
        oldAmount: '',
        bankFeeId: '',
        selectedFeeType: 'Lump Sum',
        oldSelectedFeeType: '',
        validateFromTo: newValidateFromTo,
        noDecimalAllowed: true,
      });
    }

    if (feeId > 0) {
      if (comexBankFeeList.length > 1) {
        filterUniqueFromAmountFeeUpdateLocal(fromToValue);

        for (let i = 0; i < groupedDataLocal.length; i++) {
          for (let j = 0; j < groupedDataLocal[i].fee.length; j++) {
            // Iterate over each fee within the group
            if (groupedDataLocal[i].fee[j].id === feeId) {
              setComexBankFeeForm({
                ...groupedDataLocal[i].fee[j],
                fromTo: groupedDataLocal[i].fee[j].fromTo,
                amount: groupedDataLocal[i].fee[j].amount,
              });

              let newFromValue;
              let newToLimitValue;
              let newValidateFromTo;

              if (i === 0) {
                newValidateFromTo = '1 - ' + (Number(groupedDataLocal[i]?.fromTo) + 1);
                newFromValue = 1;
                newToLimitValue = groupedDataLocal?.length > 1 ? groupedDataLocal[i + 1]?.fromTo : bankEntity?.transactionAmountLimit;
              }
              if (i !== 0 && i !== groupedDataLocal.length - 1) {
                const fromToPrev = groupedDataLocal[i - 1]?.fromTo || 0;
                const fromToNext = groupedDataLocal[i + 1]?.fromTo || 0;
                newValidateFromTo = Number(fromToPrev) + 1 + ' - ' + fromToNext;
                newFromValue = fromToPrev + 1;
                newToLimitValue = fromToNext;
              }
              if (i === groupedDataLocal.length - 1) {
                const fromToPrev = groupedDataLocal[i - 1]?.fromTo || 0;
                newValidateFromTo = Number(fromToPrev) + 1 + ' - ' + bankEntity?.transactionAmountLimit;
                newFromValue = fromToPrev + 1;
                newToLimitValue = bankEntity?.transactionAmountLimit;
              }

              setLocalFeeDialog(prev => ({
                ...prev,
                fromValue: newFromValue,
                toLimitValue: newToLimitValue,
                validateFromTo: newValidateFromTo,
              }));
            }
          }
        }
      }

      if (newComexBankFeeList?.length === 1) {
        setComexBankFeeForm({
          ...newComexBankFeeList[0],
          fromTo: newComexBankFeeList[0]?.fromTo?.toLocaleString(),
          amount: newComexBankFeeList[0]?.amount?.toLocaleString(),
        });

        setLocalFeeDialog(prev => ({
          ...prev,
          validateFromTo: '1 - 99999999999999',
          fromValue: 1,
          toLimitValue: 9999999999999,
        }));
      }
    }

    if (!isPending) {
      setLocalFeeDialog(prev => ({ ...prev, open: true }));
    }
  };

  const handleClickOpenCommission = feeId => {
    const bankCommissionById = comexBankFeeList?.find(fee => fee?.id === feeId && fee?.feeType === 'commission');
    const commissionList = comexBankFeeList?.filter(fee => fee?.id === feeId && fee?.feeType === 'commission');

    if (feeId !== 0) {
      setInternationalCommissionDialog({
        open: true,
        isNew: false,
        eachAmountValue: bankCommissionById.fromTo.toLocaleString(),
        oldEachAmountValue: bankCommissionById.fromTo.toLocaleString(),
        checkedEachAmountValue: bankCommissionById.fromTo,
        noDecimalAllowed: true,
      });

      setValue('commissionEachAmount', bankCommissionById.fromTo.toLocaleString());

      const updatedFormStateCommission = comexBankFeeList
        .filter(item => item.feeType === 'commission')
        .sort((a, b) => a.currencyId - b.currencyId)
        .map((item, index) => ({ ...item, amount: item?.amount }));

      setFormStateCommission(updatedFormStateCommission);
      setOldFormStateCommission(commissionList);
    } else {
      setInternationalCommissionDialog({
        open: true,
        isNew: true,
        eachAmountValue: '',
        oldEachAmountValue: '',
        checkedEachAmountValue: 1,
        noDecimalAllowed: true,
      });
      setValue('commissionEachAmount', '');
    }
  };

  const handleClickOpenCommissionLocal = feeId => {
    const bankCommissionById = comexBankFeeList?.find(fee => fee?.id === feeId && fee?.feeType === 'commission');
    const commissionList = comexBankFeeList?.filter(fee => fee?.id === feeId && fee?.feeType === 'commission');

    if (feeId !== 0) {
      setLocalCommissionDialog({
        open: true,
        isNew: false,
        eachAmountValue: bankCommissionById.fromTo.toLocaleString(),
        oldEachAmountValue: bankCommissionById.fromTo.toLocaleString(),
        checkedEachAmountValue: bankCommissionById.fromTo,
        noDecimalAllowed: true,
      });

      setValue('commissionEachAmount', bankCommissionById.fromTo.toLocaleString());

      const updatedFormStateCommission = comexBankFeeList
        .filter(item => item.feeType === 'commission')
        .sort((a, b) => a.currencyId - b.currencyId)
        .map((item, index) => ({ ...item, amount: item?.amount }));

      setFormStateCommissionLocal(updatedFormStateCommission);
      setOldFormStateCommissionLocal(commissionList);
    } else {
      setLocalCommissionDialog({
        open: true,
        isNew: true,
        eachAmountValue: '',
        oldEachAmountValue: '',
        checkedEachAmountValue: 1,
        noDecimalAllowed: true,
      });
      setValue('commissionEachAmount', '');
    }
  };

  const handleFeeTypeChangeInternational = useCallback(e => {
    setInternationalFeeDialog(prev => ({ ...prev, selectedFeeType: e.target.value }));
  }, []);

  const handleFeeTypeChangeLocal = useCallback(e => {
    setLocalFeeDialog(prev => ({ ...prev, selectedFeeType: e.target.value }));
  }, []);

  const handleClose = useCallback(() => {
    setComexBankFeeForm({});
    let newFromValue = 1;
    if (newComexBankFeeList?.length !== 0) {
      const maxFromTo = Math.max(...newComexBankFeeList.map(item => Number(item.fromTo))) + 1;
      newFromValue = maxFromTo;
    }

    setInternationalCommissionDialog({
      open: false,
      isNew: true,
      eachAmountValue: '',
      oldEachAmountValue: '',
      checkedEachAmountValue: 1,
      noDecimalAllowed: true,
    });

    setInternationalFeeDialog({
      open: false,
      isNew: true,
      fromValue: newFromValue,
      toValue: '',
      oldToValue: '',
      checkedToValue: 1,
      toValueDisplayed: '',
      toLimitValue: bankEntity?.transactionAmountLimit,
      amount: '',
      checkedAmount: 1,
      amountDisplayed: '',
      oldAmount: '',
      bankFeeId: '',
      selectedFeeType: 'Lump Sum',
      oldSelectedFeeType: '',
      validateFromTo: '',
      noDecimalAllowed: true,
    });

    setOldFormStateFee([]);
    setOldFormStateCommission([]);
    filterUniqueFromAmountFee();

    // Clear tracking maps
    setModifiedFees(new Map());
    setModifiedCommissions(new Map());

    const updatedFormStateFee = formStateFee
      .map(item => ({
        ...item,
        amount: '',
      }))
      .sort((a, b) => a.currencyId - b.currencyId);

    setFormStateFee(updatedFormStateFee);

    const updatedFormStateCommission = formStateCommission.map(item => ({
      ...item,
      amount: '',
    }));
    setFormStateCommission(updatedFormStateCommission);
  }, [newComexBankFeeList, bankEntity?.transactionAmountLimit, formStateFee, formStateCommission]);

  const handleCloseLocal = useCallback(() => {
    setComexBankFeeForm({});
    let newFromValue = 1;
    if (newComexBankFeeList?.length !== 0) {
      const maxFromTo = Math.max(...newComexBankFeeList.map(item => Number(item.fromTo))) + 1;
      newFromValue = maxFromTo;
    }

    setLocalCommissionDialog({
      open: false,
      isNew: true,
      eachAmountValue: '',
      oldEachAmountValue: '',
      checkedEachAmountValue: 1,
      noDecimalAllowed: true,
    });

    setLocalFeeDialog({
      open: false,
      isNew: true,
      fromValue: newFromValue,
      toValue: '',
      oldToValue: '',
      checkedToValue: 1,
      toValueDisplayed: '',
      toLimitValue: bankEntity?.transactionAmountLimit,
      amount: '',
      checkedAmount: 1,
      amountDisplayed: '',
      oldAmount: '',
      bankFeeId: '',
      selectedFeeType: 'Lump Sum',
      oldSelectedFeeType: '',
      validateFromTo: '',
      noDecimalAllowed: true,
    });

    setOldFormStateFeeLocal([]);
    setOldFormStateCommissionLocal([]);
    filterUniqueFromAmountFeeLocal();

    // Clear tracking maps
    setModifiedFeesLocal(new Map());
    setModifiedCommissionsLocal(new Map());

    const updatedFormStateFee = formStateFeeLocal
      .map(item => ({
        ...item,
        amount: '',
      }))
      .sort((a, b) => a.currencyId - b.currencyId);

    setFormStateFeeLocal(updatedFormStateFee);

    const updatedFormStateCommission = formStateCommissionLocal.map(item => ({
      ...item,
      amount: '',
    }));
    setFormStateCommissionLocal(updatedFormStateCommission);
  }, [newComexBankFeeList, bankEntity?.transactionAmountLimit, formStateFeeLocal, formStateCommissionLocal]);

  const handleEditBank = () => {
    props.history.push(`/bank/${bankEntity?.id}/edit`);
  };

  const handleEditBranchClose = () => {
    setBranchName(branchValue);
    setOpenBranchEdit(false);
  };

  const handleCreateBranchClose = () => {
    setOpenBranchCreate(false);
    setBranchNameInput('');
    setIsBranchEmpty(false);
    setIsBranchExists(false);
  };

  const handleCommission = e => {
    setIsCommissionAmountFieldClicked(false);
    setIsCommissionForEachFieldClicked(false);
    const bankCommissionEntity = {
      ...bankEntity,
      commission: e.target.checked,
    };

    const commissionLogEntity = {
      ...commissionLog,
      id: null,
      commission: e.target.checked,
      commissionAmount: checkedCommissionAmt ? Number(String(checkedCommissionAmt).replace(/,/g, '')) : 0,
      commissionForEachAmount: checkedCommissionForEachAmt ? Number(String(checkedCommissionForEachAmt).replace(/,/g, '')) : 0,
      bankId: bankEntity?.id,
    };

    dispatch(updateBank(bankCommissionEntity));
    dispatch(createCommissionLog(commissionLogEntity));
    setCommissionData(e.target.checked);
    if (e.target.checked === true) {
      setUpdateCommission(false);
    } else {
      setUpdateCommission(true);
    }
  };

  const handleCommissionLocal = e => {
    const bankCommissionEntity = {
      ...bankEntity,
      commissionLocal: e.target.checked,
    };
    const commissionLogEntity = {
      ...commissionLog,
      id: null,
      commissionLocal: e.target.checked,
      commissionAmount: checkedCommissionAmt ? Number(String(checkedCommissionAmt).replace(/,/g, '')) : 0,
      commissionForEachAmount: checkedCommissionForEachAmt ? Number(String(checkedCommissionForEachAmt).replace(/,/g, '')) : 0,
      bankId: bankEntity?.id,
    };

    dispatch(updateBank(bankCommissionEntity));
    dispatch(createCommissionLog(commissionLogEntity));
    setCommissionDataLocal(e.target.checked);
    if (e.target.checked === true) {
      setUpdateCommissionLocal(false);
    } else {
      setUpdateCommissionLocal(true);
    }
  };

  const handleCommissionAmount = e => {
    setIsCommissionAmountFieldClicked(true);
    setIsCommissionForEachFieldClicked(false);
    const commissionAmountValue = toEnglishDigits(e.target.value);
    // console.warn("commissionAmountValue"+commissionAmountValue);
    const commissionAmountDecimalPoints = commissionAmountValue.toString().split('.');
    // console.warn("commissionAmountDecimalPoints"+commissionAmountDecimalPoints);
    if (
      commissionAmountValue.toString().charAt(commissionAmountValue.length - 1) !== '.' &&
      isNumber(commissionAmountValue.toString().charAt(commissionAmountValue.length - 1)) &&
      commissionAmountValue.length < 20
    ) {
      const enteredCommissionAmount = commissionAmountValue.replace(/,/g, '');
      // console.warn("enteredCommissionAmount"+enteredCommissionAmount);
      setCheckedCommissionAmt(Number(enteredCommissionAmount) || 0);
      const cleanedCommissionAmount = enteredCommissionAmount.replace(/[^0-9.]+/g, '');
      // console.warn("cleanedCommissionAmount"+cleanedCommissionAmount);
      setCommissionAmt(cleanedCommissionAmount.toLocaleString());
    } else if (
      commissionAmountValue.toString().charAt(commissionAmountValue.length - 1) === '.' &&
      commissionAmountDecimalPoints.length === 2 &&
      commissionAmountValue.length < 20
    ) {
      setCommissionAmt(commissionAmountValue.toLocaleString());
    } else {
      setCommissionAmt(commissionAmountValue.slice(0, -1).toLocaleString());
    }
  };

  const handleCommissionForEachAmount = e => {
    setIsCommissionAmountFieldClicked(false);
    setIsCommissionForEachFieldClicked(true);
    setCommissionnForEachAmt(e.target.value);
    const commissionForEachAmtValue = toEnglishDigits(e.target.value);
    // console.warn("commissionForEachAmtValue"+commissionForEachAmtValue);
    const commissionForEachAmtDecimalPoints = commissionForEachAmtValue.toString().split('.');
    // console.warn("commissionForEachAmtDecimalPoints"+commissionForEachAmtDecimalPoints);
    if (
      commissionForEachAmtValue.toString().charAt(commissionForEachAmtValue.length - 1) !== '.' &&
      isNumber(commissionForEachAmtValue.toString().charAt(commissionForEachAmtValue.length - 1)) &&
      commissionForEachAmtValue.length < 20
    ) {
      const enteredCommissionForEachAmount = commissionForEachAmtValue.replace(/,/g, '');
      // console.warn("enteredCommissionAmount"+enteredCommissionForEachAmount);
      setCheckedCommissionForEachAmt(Number(enteredCommissionForEachAmount) || 0);
      const cleanedCommissionForEachAmount = enteredCommissionForEachAmount.replace(/[^0-9.]+/g, '');
      // console.warn("cleanedCommissionAmount"+cleanedCommissionForEachAmount);
      setCommissionnForEachAmt(cleanedCommissionForEachAmount.toLocaleString());
    } else if (
      commissionForEachAmtValue.toString().charAt(commissionForEachAmtValue.length - 1) === '.' &&
      commissionForEachAmtDecimalPoints.length === 2 &&
      commissionForEachAmtValue.length < 20
    ) {
      setCommissionnForEachAmt(commissionForEachAmtValue.toLocaleString());
    } else {
      setCommissionnForEachAmt(commissionForEachAmtValue.slice(0, -1).toLocaleString());
    }
  };
  const updateCommissionBank = () => {
    setIsCommissionAmountFieldClicked(false);
    setIsCommissionForEachFieldClicked(false);
    const bankCommissionEntity = {
      ...bankEntity,
      commission: commissionData,
      commissionAmount: checkedCommissionAmt ? Number(String(checkedCommissionAmt).replace(/,/g, '')) : 0,
      commissionForEachAmount: checkedCommissionForEachAmt ? Number(String(checkedCommissionForEachAmt).replace(/,/g, '')) : 0,
    };

    const commissionLogEntity = {
      ...commissionLog,
      commission: commissionData,
      commissionAmount: checkedCommissionAmt ? Number(String(checkedCommissionAmt).replace(/,/g, '')) : 0,
      commissionForEachAmount: checkedCommissionForEachAmt ? Number(String(checkedCommissionForEachAmt).replace(/,/g, '')) : 0,
      bankId: bankEntity?.id,
    };

    if (
      bankEntity?.commissionAmount !== checkedCommissionAmt ||
      bankEntity?.commissionForEachAmount !== checkedCommissionForEachAmt ||
      bankEntity?.commission !== commissionData
    ) {
      dispatch(updateBank(bankCommissionEntity));
      dispatch(createCommissionLog(commissionLogEntity));
    }
  };

  const updateNewCommissionBank = values => {
    setIsCommissionForEachFieldClicked(false);
    const bankCommissionEntity = {
      ...bankEntity,
      commission: commissionData,
    };
    const commissionLogEntity = {
      ...commissionLog,
      commission: commissionData,
      bankId: bankEntity?.id,
    };
    if (bankEntity?.commission !== commissionData) {
      dispatch(updateBank(bankCommissionEntity));
      dispatch(createCommissionLog(commissionLogEntity));
    }

    // new
    if (updatedCommissionArray?.length === 0 && internationalCommissionDialog.oldEachAmountValue === '') {
      availableCurrency.forEach((fee, index) => {
        const entity = {
          ...comexBankFeeForm,
          ...values,
          fromTo: Number(internationalCommissionDialog.eachAmountValue),
          feeType: 'commission',
          amount: parseAmountValue(formStateCommission[index]?.amount),
          bank: bankEntity,
          bankId: props.match.params.id,
          currencyId: formStateCommission[index]?.currencyId,
        };
        const bankCommissionLog = {
          ...comexBankFeeForm,
          ...values,
          fromTo: Number(internationalCommissionDialog.eachAmountValue),
          feeType: 'commission',
          amount: parseAmountValue(formStateCommission[index]?.amount),
          status: 'CREATE',
          bank: bankEntity,
          bankId: props.match.params.id,
          currencyId: formStateCommission[index]?.currencyId,
        };
        dispatch(createComexBankFee(entity));
        dispatch(createComexBankFeeLog(bankCommissionLog));
      });
    }

    // update commission each amount (fromTo)
    if (
      internationalCommissionDialog.oldEachAmountValue !== '' &&
      Number(internationalCommissionDialog.oldEachAmountValue.replace(/,/g, '')) !==
        Number(internationalCommissionDialog.eachAmountValue.replace(/,/g, ''))
    ) {
      formStateCommission.forEach((item, index) => {
        console.warn('test each amount');
        const entity = {
          ...item,
          ...values,
          id: item?.id,
          fromTo: internationalCommissionDialog.checkedEachAmountValue,
          feeType: item?.feeType,
          amount: item?.amount ? parseFloat(String(item?.amount).replace(/,/g, '')) : 0,
          bank: bankEntity,
          bankId: props.match.params.id,
          currencyId: item?.currencyId,
        };
        const bankCommissionLog = {
          ...comexBankFeeForm,
          ...values,
          id: null,
          fromTo: internationalCommissionDialog.checkedEachAmountValue,
          feeType: item?.feeType,
          amount: item?.amount ? parseFloat(String(item?.amount).replace(/,/g, '')) : 0,
          status: 'UPDATE',
          bank: bankEntity,
          bankId: props.match.params.id,
          currencyId: item?.currencyId,
        };
        dispatch(updateComexBankFee(entity));
        dispatch(createComexBankFeeLog(bankCommissionLog));
      });
    }

    // update commission amount (amount) - support multi-currency update
    if (updatedCommissionArray?.length > 0 || modifiedCommissions.size > 0) {
      // Process tracked modifications from Map
      if (modifiedCommissions.size > 0) {
        modifiedCommissions.forEach((newAmount, currencyId) => {
          const foundItem = comexBankFeeList?.find(item => item?.currencyId === currencyId && item?.feeType === 'commission');
          if (foundItem) {
            const cleanedAmount = Number(parseFloat(String(newAmount).replace(/,/g, '')).toFixed(2));
            const entity = {
              ...foundItem,
              ...values,
              id: foundItem?.id,
              fromTo: internationalCommissionDialog.checkedEachAmountValue,
              feeType: foundItem?.feeType,
              amount: cleanedAmount,
              bank: bankEntity,
              bankId: props.match.params.id,
              currencyId: foundItem?.currencyId,
            };
            const bankCommissionLog = {
              ...comexBankFeeForm,
              ...values,
              id: null,
              fromTo: foundItem?.fromTo,
              feeType: foundItem?.feeType,
              amount: cleanedAmount,
              status: 'UPDATE',
              bank: bankEntity,
              bankId: props.match.params.id,
              currencyId: foundItem?.currencyId,
            };
            dispatch(updateComexBankFee(entity));
            dispatch(createComexBankFeeLog(bankCommissionLog));
          }
        });
      } else {
        // Fallback to old logic if no modifications tracked
        updatedCommissionArray?.forEach((value, index) => {
          const foundItem = comexBankFeeList?.find(item => item?.id?.toString() === value?.id);
          if (foundItem) {
            const entity = {
              ...foundItem,
              ...values,
              id: foundItem?.id,
              fromTo: internationalCommissionDialog.checkedEachAmountValue,
              feeType: foundItem?.feeType,
              amount: Number(parseFloat(String(value?.newAmount).replace(/,/g, '')).toFixed(2)),
              bank: bankEntity,
              bankId: props.match.params.id,
              currencyId: foundItem?.currencyId,
            };
            const bankCommissionLog = {
              ...comexBankFeeForm,
              ...values,
              id: null,
              fromTo: foundItem?.fromTo,
              feeType: foundItem?.feeType,
              amount: Number(parseFloat(String(value?.newAmount).replace(/,/g, '')).toFixed(2)),
              status: 'UPDATE',
              bank: bankEntity,
              bankId: props.match.params.id,
              currencyId: foundItem?.currencyId,
            };
            dispatch(updateComexBankFee(entity));
            dispatch(createComexBankFeeLog(bankCommissionLog));
          }
        });
      }
    }

    handleClose();
  };

  const updateNewCommissionBankLocal = values => {
    setIsCommissionForEachFieldClicked(false);
    const bankCommissionEntity = {
      ...bankEntity,
      commissionLocal: commissionDataLocal,
    };
    const commissionLogEntity = {
      ...commissionLog,
      commissionLocal: commissionDataLocal,
      bankId: bankEntity?.id,
    };
    if (bankEntity?.commissionLocal !== commissionDataLocal) {
      dispatch(updateBank(bankCommissionEntity));
      dispatch(createCommissionLog(commissionLogEntity));
    }

    // new
    if (updatedCommissionArrayLocal?.length === 0 && localCommissionDialog.oldEachAmountValue === '') {
      availableCurrencyLocal.forEach((fee, index) => {
        const entity = {
          ...comexBankFeeForm,
          ...values,
          fromTo: Number(localCommissionDialog.eachAmountValue),
          feeType: 'commission',
          amount: parseAmountValue(formStateCommissionLocal[index]?.amount),
          bank: bankEntity,
          bankId: props.match.params.id,
          currencyId: formStateCommissionLocal[index]?.currencyId,
          commodityType: 'Local',
        };
        const bankCommissionLog = {
          ...comexBankFeeForm,
          ...values,
          fromTo: Number(localCommissionDialog.eachAmountValue),
          feeType: 'commission',
          amount: parseAmountValue(formStateCommissionLocal[index]?.amount),
          status: 'CREATE',
          bank: bankEntity,
          bankId: props.match.params.id,
          currencyId: formStateCommissionLocal[index]?.currencyId,
          commodityType: 'Local',
        };
        dispatch(createComexBankFee(entity));
        dispatch(createComexBankFeeLog(bankCommissionLog));
      });
    }

    // update commission each amount (fromTo)
    if (
      localCommissionDialog.oldEachAmountValue !== '' &&
      Number(localCommissionDialog.oldEachAmountValue.replace(/,/g, '')) !== Number(localCommissionDialog.eachAmountValue.replace(/,/g, ''))
    ) {
      formStateCommissionLocal.forEach((item, index) => {
        const entity = {
          ...item,
          ...values,
          id: item?.id,
          fromTo: localCommissionDialog.checkedEachAmountValue,
          feeType: item?.feeType,
          amount: item?.amount ? parseFloat(String(item?.amount).replace(/,/g, '')) : 0,
          bank: bankEntity,
          bankId: props.match.params.id,
          currencyId: item?.currencyId,
          commodityType: 'Local',
        };
        const bankCommissionLog = {
          ...comexBankFeeForm,
          ...values,
          id: null,
          fromTo: localCommissionDialog.checkedEachAmountValue,
          feeType: item?.feeType,
          amount: item?.amount ? parseFloat(String(item?.amount).replace(/,/g, '')) : 0,
          status: 'UPDATE',
          bank: bankEntity,
          bankId: props.match.params.id,
          currencyId: item?.currencyId,
          commodityType: 'Local',
        };
        dispatch(updateComexBankFee(entity));
        dispatch(createComexBankFeeLog(bankCommissionLog));
      });
    }

    // update commission amount (amount) - support multi-currency update
    if (updatedCommissionArrayLocal?.length > 0 || modifiedCommissionsLocal.size > 0) {
      // Process tracked modifications from Map
      if (modifiedCommissionsLocal.size > 0) {
        modifiedCommissionsLocal.forEach((newAmount, currencyId) => {
          const foundItem = comexBankFeeList?.find(item => item?.currencyId === currencyId && item?.feeType === 'commission');
          if (foundItem) {
            const cleanedAmount = Number(parseFloat(String(newAmount).replace(/,/g, '')).toFixed(2));
            const entity = {
              ...foundItem,
              ...values,
              id: foundItem?.id,
              fromTo: localCommissionDialog.checkedEachAmountValue,
              feeType: foundItem?.feeType,
              amount: cleanedAmount,
              bank: bankEntity,
              bankId: props.match.params.id,
              currencyId: foundItem?.currencyId,
              commodityType: 'Local',
            };
            const bankCommissionLog = {
              ...comexBankFeeForm,
              ...values,
              id: null,
              fromTo: foundItem?.fromTo,
              feeType: foundItem?.feeType,
              amount: cleanedAmount,
              status: 'UPDATE',
              bank: bankEntity,
              bankId: props.match.params.id,
              currencyId: foundItem?.currencyId,
              commodityType: 'Local',
            };
            dispatch(updateComexBankFee(entity));
            dispatch(createComexBankFeeLog(bankCommissionLog));
          }
        });
      } else {
        // Fallback to old logic if no modifications tracked
        updatedCommissionArrayLocal?.forEach((value, index) => {
          const foundItem = comexBankFeeList?.find(item => item?.id?.toString() === value?.id);
          if (foundItem) {
            const entity = {
              ...foundItem,
              ...values,
              id: foundItem?.id,
              fromTo: localCommissionDialog.checkedEachAmountValue,
              feeType: foundItem?.feeType,
              amount: Number(parseFloat(String(value?.newAmount).replace(/,/g, '')).toFixed(2)),
              bank: bankEntity,
              bankId: props.match.params.id,
              currencyId: foundItem?.currencyId,
              commodityType: 'Local',
            };
            const bankCommissionLog = {
              ...comexBankFeeForm,
              ...values,
              id: null,
              fromTo: foundItem?.fromTo,
              feeType: foundItem?.feeType,
              amount: Number(parseFloat(String(value?.newAmount).replace(/,/g, '')).toFixed(2)),
              status: 'UPDATE',
              bank: bankEntity,
              bankId: props.match.params.id,
              currencyId: foundItem?.currencyId,
              commodityType: 'Local',
            };
            dispatch(updateComexBankFee(entity));
            dispatch(createComexBankFeeLog(bankCommissionLog));
          }
        });
      }
    }

    handleCloseLocal();
  };

  const handleFromToValidate = useCallback(
    e => {
      const value = Number(e.target.value);

      setInternationalFeeDialog(prev => ({
        ...prev,
        fromValue: value,
      }));

      if (value === 1) {
        if (newComexBankFeeList?.length > 1) {
          setInternationalFeeDialog(prev => ({
            ...prev,
            toLimitValue: newComexBankFeeList[0]?.fromTo,
            validateFromTo: value + 1 + ' - ' + newComexBankFeeList[0]?.fromTo,
          }));
        }
      }
      if (value > 1) {
        if (newComexBankFeeList?.length === 1) {
          setInternationalFeeDialog(prev => ({
            ...prev,
            toLimitValue: 9999999999999,
            validateFromTo: value + 1 + ' - 9999999999999',
          }));
        } else {
          for (let i = 0; i < newComexBankFeeList?.length; i++) {
            if ((newComexBankFeeList[i]?.fromTo + 1).toString() === e.target.value.toString()) {
              if (i === 0) {
                setInternationalFeeDialog(prev => ({
                  ...prev,
                  toLimitValue: newComexBankFeeList[i + 1]?.fromTo,
                  validateFromTo: value + 1 + ' - ' + newComexBankFeeList[i + 1]?.fromTo,
                }));
              }
              if (i !== 0 && i !== newComexBankFeeList?.length - 1) {
                setInternationalFeeDialog(prev => ({
                  ...prev,
                  toLimitValue: newComexBankFeeList[i + 1]?.fromTo,
                  validateFromTo: value + 1 + ' - ' + newComexBankFeeList[i + 1]?.fromTo,
                }));
              }
              if (i === newComexBankFeeList?.length - 1) {
                setInternationalFeeDialog(prev => ({
                  ...prev,
                  toLimitValue: 9999999999999,
                  validateFromTo: value + 1 + ' - 9999999999999',
                }));
              }
            }
          }
        }
      }
    },
    [newComexBankFeeList]
  );

  const handleFromToValidateLocal = useCallback(
    e => {
      const value = Number(e.target.value);

      setLocalFeeDialog(prev => ({
        ...prev,
        fromValue: value,
      }));

      if (value === 1) {
        if (newComexBankFeeList?.length > 1) {
          setLocalFeeDialog(prev => ({
            ...prev,
            toLimitValue: newComexBankFeeList[0]?.fromTo,
            validateFromTo: value + 1 + ' - ' + newComexBankFeeList[0]?.fromTo,
          }));
        }
      }
      if (value > 1) {
        if (newComexBankFeeList?.length === 1) {
          setLocalFeeDialog(prev => ({
            ...prev,
            toLimitValue: 9999999999999,
            validateFromTo: value + 1 + ' - 9999999999999',
          }));
        } else {
          for (let i = 0; i < newComexBankFeeList?.length; i++) {
            if ((newComexBankFeeList[i]?.fromTo + 1).toString() === e.target.value.toString()) {
              if (i === 0) {
                setLocalFeeDialog(prev => ({
                  ...prev,
                  toLimitValue: newComexBankFeeList[i + 1]?.fromTo,
                  validateFromTo: value + 1 + ' - ' + newComexBankFeeList[i + 1]?.fromTo,
                }));
              }
              if (i !== 0 && i !== newComexBankFeeList?.length - 1) {
                setLocalFeeDialog(prev => ({
                  ...prev,
                  toLimitValue: newComexBankFeeList[i + 1]?.fromTo,
                  validateFromTo: value + 1 + ' - ' + newComexBankFeeList[i + 1]?.fromTo,
                }));
              }
              if (i === newComexBankFeeList?.length - 1) {
                setLocalFeeDialog(prev => ({
                  ...prev,
                  toLimitValue: 9999999999999,
                  validateFromTo: value + 1 + ' - 9999999999999',
                }));
              }
            }
          }
        }
      }
    },
    [newComexBankFeeList]
  );

  // useEffect(() => {
  //   if(isNew && fromValue===1 && parseInt(toValue,10)===comexBankFeeList[0]?.fromTo){
  //     setValidateFromTo("1-"+(Number(comexBankFeeList[0]?.fromTo)-1));}
  // }, [isNew,fromValue,toValue]);

  useEffect(() => {
    if (bankEntity?.id !== undefined) {
      setCommissionData(bankEntity?.commission);
      setCommissionDataLocal(bankEntity?.commissionLocal);
      setUpdateCommission(!bankEntity?.commission);
      setUpdateCommissionLocal(!bankEntity?.commissionLocal);
      setCommissionAmt(bankEntity?.commissionAmount?.toLocaleString());
      setCheckedCommissionAmt(bankEntity?.commissionAmount);
      setCheckedCommissionForEachAmt(bankEntity?.commissionForEachAmount);
      setCommissionnForEachAmt(bankEntity?.commissionForEachAmount?.toLocaleString());

      dispatch(getEntityByBankId(bankEntity?.id))
        .then(res => {
          const data = (res.payload as { data: { sellConfirmationEndpoint?: string; vendorName?: string; vendorCif?: string } })?.data;
          setValueSellConfirmationEndpoint(data?.sellConfirmationEndpoint || '');
          setValueVendorName(data?.vendorName || '');
          setValueVendorCif(data?.vendorCif || '');
        })
        .catch(error => {
          setValueSellConfirmationEndpoint('');
          setValueVendorName('');
          setValueVendorCif('');
        });
    }
  }, [bankEntity]);

  const saveEntity = async values => {
    setIsPending(true);
    const dispatchPromises = [];
    try {
      // Lump Sum
      if (internationalFeeDialog.selectedFeeType === 'Lump Sum') {
        // new - lump sum
        if (internationalFeeDialog.isNew && updatedFeeArray?.length === 0) {
          if (internationalFeeDialog.oldToValue === '' && internationalFeeDialog.oldSelectedFeeType === '') {
            availableCurrency.forEach((fee, index) => {
              const entity = {
                ...comexBankFeeForm,
                ...values,
                feeType: internationalFeeDialog.selectedFeeType,
                fromTo: internationalFeeDialog.checkedToValue,
                amount: parseAmountValue(formStateFee[index]?.amount),
                currencyId: formStateFee[index]?.currencyId,
                bank: bankEntity,
                bankId: props.match.params.id,
              };
              const bankFeeLog = {
                ...comexBankFeeForm,
                ...values,
                feeType: internationalFeeDialog.selectedFeeType,
                fromTo: internationalFeeDialog.checkedToValue,
                amount: parseAmountValue(formStateFee[index]?.amount),
                currencyId: formStateFee[index]?.currencyId,
                bank: bankEntity,
                bankId: props.match.params.id,
                status: 'CREATE',
              };
              dispatchPromises.push(dispatch(createComexBankFee(entity)));
              dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
            });
          }
        } else {
          // edit fee type
          if (
            internationalFeeDialog.oldSelectedFeeType !== '' &&
            internationalFeeDialog.oldSelectedFeeType !== internationalFeeDialog.selectedFeeType
          ) {
            const newRows = formStateFee?.slice(1, formStateFee?.length);
            newRows?.forEach((fee, index) => {
              const entity = {
                ...comexBankFeeForm,
                ...values,
                id: null,
                feeType: internationalFeeDialog.selectedFeeType,
                fromTo: internationalFeeDialog.checkedToValue,
                amount: parseAmountValue(formStateFee[index + 1]?.amount),
                currencyId: formStateFee[index + 1]?.currencyId,
                bank: bankEntity,
                bankId: props.match.params.id,
              };
              const bankFeeLogOtherEntities = {
                ...comexBankFeeForm,
                ...values,
                id: null,
                feeType: internationalFeeDialog.selectedFeeType,
                fromTo: internationalFeeDialog.checkedToValue,
                amount: parseAmountValue(formStateFee[index + 1]?.amount),
                currencyId: formStateFee[index + 1]?.currencyId,
                bank: bankEntity,
                bankId: props.match.params.id,
                status: 'CREATE',
              };
              dispatchPromises.push(dispatch(createComexBankFee(entity)));
              dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLogOtherEntities)));
            });

            const foundItem = comexBankFeeList?.find(item => item?.id?.toString() === internationalFeeDialog.bankFeeId);
            const firstEntity = {
              ...foundItem,
              ...values,
              id: foundItem?.id,
              feeType: internationalFeeDialog.selectedFeeType,
              fromTo: internationalFeeDialog.checkedToValue,
              amount: parseAmountValue(formStateFee[0]?.amount),
              currencyId: formStateFee[0]?.currencyId,
              bank: bankEntity,
              bankId: props.match.params.id,
            };
            const bankFeeLogfirstEntity = {
              ...comexBankFeeForm,
              ...values,
              id: null,
              feeType: internationalFeeDialog.selectedFeeType,
              fromTo: internationalFeeDialog.checkedToValue,
              amount: parseAmountValue(formStateFee[0]?.amount),
              currencyId: formStateFee[0]?.currencyId,
              bank: bankEntity,
              bankId: props.match.params.id,
              status: 'UPDATE',
            };
            dispatchPromises.push(dispatch(updateComexBankFee(firstEntity)));
            dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLogfirstEntity)));
          }

          // edit to value - lump sum
          if (internationalFeeDialog.oldToValue !== '' && internationalFeeDialog.oldToValue !== internationalFeeDialog.toValue) {
            formStateFee.forEach((item, index) => {
              const entity = {
                ...item,
                ...values,
                id: item?.id,
                fromTo: internationalFeeDialog.checkedToValue,
                feeType: item?.feeType,
                amount: item?.amount ? parseFloat(String(item?.amount).replace(/,/g, '')) : 0,
                bank: bankEntity,
                bankId: props.match.params.id,
                currencyId: item?.currencyId,
              };
              const bankFeeLog = {
                ...comexBankFeeForm,
                ...values,
                id: null,
                fromTo: internationalFeeDialog.checkedToValue,
                feeType: item?.feeType,
                amount: item?.amount ? parseFloat(String(item?.amount).replace(/,/g, '')) : 0,
                status: 'UPDATE',
                bank: bankEntity,
                bankId: props.match.params.id,
                currencyId: item?.currencyId,
              };
              dispatchPromises.push(dispatch(updateComexBankFee(entity)));
              dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
            });
          }

          // edit amount - lump sum (support multi-currency update)
          if (updatedFeeArray?.length > 0 || modifiedFees.size > 0) {
            // Process tracked modifications from Map
            if (modifiedFees.size > 0) {
              modifiedFees.forEach((newAmount, currencyId) => {
                const foundItem = comexBankFeeList?.find(
                  item =>
                    item?.currencyId === currencyId &&
                    item?.fromTo === internationalFeeDialog.checkedToValue &&
                    item?.feeType === 'Lump Sum'
                );
                if (foundItem) {
                  const cleanedAmount = Number(parseFloat(String(newAmount).replace(/,/g, '')).toFixed(2));
                  const entity = {
                    ...foundItem,
                    ...values,
                    id: foundItem?.id,
                    currencyId: Number(foundItem?.currencyId),
                    feeType: foundItem?.feeType,
                    fromTo: internationalFeeDialog.checkedToValue,
                    amount: cleanedAmount,
                    bank: bankEntity,
                    bankId: props.match.params.id,
                  };
                  const bankFeeLog = {
                    ...comexBankFeeForm,
                    ...values,
                    feeType: foundItem?.feeType,
                    fromTo: internationalFeeDialog.checkedToValue,
                    amount: cleanedAmount,
                    currencyId: Number(foundItem?.currencyId),
                    id: null,
                    bank: bankEntity,
                    bankId: props.match.params.id,
                    status: 'UPDATE',
                  };
                  dispatchPromises.push(dispatch(updateComexBankFee(entity)));
                  dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
                }
              });
            } else {
              // Fallback to old logic if no modifications tracked
              updatedFeeArray?.forEach((value, index) => {
                const foundItem = comexBankFeeList?.find(item => item?.id?.toString() === value?.id);
                if (foundItem) {
                  const entity = {
                    ...foundItem,
                    ...values,
                    id: foundItem?.id,
                    currencyId: Number(foundItem?.currencyId),
                    feeType: foundItem?.feeType,
                    fromTo: internationalFeeDialog.checkedToValue,
                    amount: Number(parseFloat(String(value?.newAmount).replace(/,/g, '')).toFixed(2)),
                    bank: bankEntity,
                    bankId: props.match.params.id,
                  };
                  const bankFeeLog = {
                    ...comexBankFeeForm,
                    ...values,
                    feeType: foundItem?.feeType,
                    fromTo: internationalFeeDialog.checkedToValue,
                    amount: Number(parseFloat(String(value?.newAmount).replace(/,/g, '')).toFixed(2)),
                    currencyId: Number(foundItem?.currencyId),
                    id: null,
                    bank: bankEntity,
                    bankId: props.match.params.id,
                    status: 'UPDATE',
                  };
                  dispatchPromises.push(dispatch(updateComexBankFee(entity)));
                  dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
                }
              });
            }
          }
        }
        // Percentage
      } else if (internationalFeeDialog.selectedFeeType === 'Percentage') {
        // new - percentage
        if (internationalFeeDialog.isNew && internationalFeeDialog.oldAmount === '') {
          const entity = {
            ...comexBankFeeForm,
            ...values,
            feeType: internationalFeeDialog.selectedFeeType,
            fromTo: internationalFeeDialog.checkedToValue,
            amount: internationalFeeDialog.checkedAmount,
            bank: bankEntity,
            bankId: props.match.params.id,
          };
          const bankFeeLog = {
            ...comexBankFeeForm,
            ...values,
            feeType: internationalFeeDialog.selectedFeeType,
            fromTo: internationalFeeDialog.checkedToValue,
            amount: internationalFeeDialog.checkedAmount,
            bank: bankEntity,
            bankId: props.match.params.id,
            status: 'CREATE',
          };
          dispatchPromises.push(dispatch(createComexBankFee(entity)));
          dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
          // edit amount - percentage
        } else {
          const foundItem = comexBankFeeList?.find(item => item?.id?.toString() === internationalFeeDialog.bankFeeId);

          // edit fee type
          if (foundItem?.feeType === 'Lump Sum') {
            const entity = {
              ...foundItem,
              ...values,
              id: foundItem?.id,
              fromTo: internationalFeeDialog.checkedToValue,
              feeType: internationalFeeDialog.selectedFeeType,
              amount: internationalFeeDialog.checkedAmount,
              bank: bankEntity,
              bankId: foundItem?.bankId,
              currencyId: null,
            };
            const bankFeeLog = {
              ...comexBankFeeForm,
              ...values,
              fromTo: internationalFeeDialog.checkedToValue,
              feeType: internationalFeeDialog.selectedFeeType,
              amount: internationalFeeDialog.checkedAmount,
              id: null,
              bank: bankEntity,
              bankId: props.match.params.id,
              status: 'UPDATE',
              currencyId: null,
            };
            dispatchPromises.push(dispatch(updateComexBankFee(entity)));
            dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));

            const filteredData = comexBankFeeList?.filter(
              item => item?.fromTo === internationalFeeDialog.checkedToValue && item?.id?.toString() !== internationalFeeDialog.bankFeeId
            );
            filteredData?.map(item => {
              const comexBankFeelog = {
                ...comexBankFeeForm,
                ...values,
                id: null,
                fromTo: item.fromTo,
                status: 'DELETE',
                amount: item?.amount,
                bank: bankEntity,
                bankId: props.match.params.id,
                currencyId: item?.currencyId,
              };
              dispatchPromises.push(dispatch(createComexBankFeeLog(comexBankFeelog)));
              dispatchPromises.push(
                dispatch(deleteEntityFromBank({ id: item?.id, bankId: bankEntity?.id, fromTo: internationalFeeDialog.checkedToValue }))
              );
            });
          } else {
            const entity = {
              ...foundItem,
              ...values,
              id: Number(internationalFeeDialog.bankFeeId),
              fromTo: internationalFeeDialog.checkedToValue,
              amount: internationalFeeDialog.checkedAmount,
              bank: bankEntity,
              bankId: props.match.params.id,
              feeType: internationalFeeDialog.selectedFeeType,
              currencyId: null,
            };
            const bankFeeLog = {
              ...foundItem,
              ...values,
              fromTo: internationalFeeDialog.checkedToValue,
              feeType: internationalFeeDialog.selectedFeeType,
              amount: internationalFeeDialog.checkedAmount,
              id: null,
              bank: bankEntity,
              bankId: props.match.params.id,
              status: 'UPDATE',
            };
            dispatchPromises.push(dispatch(updateComexBankFee(entity)));
            dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
          }
        }
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      await Promise.all(dispatchPromises);
      setIsPending(false);
      handleClose();
      // dispatch(getFeeListByBankId(props.match.params.id));
      dispatch(
        getFeeListByBankIdAndCommodityType({
          bankId: props.match.params.id,
          commodityType: 'International',
        })
      );
    }
  };

  const saveEntityLocal = async values => {
    setIsPending(true);
    const dispatchPromises = [];
    try {
      // Lump Sum
      if (localFeeDialog.selectedFeeType === 'Lump Sum') {
        // new - lump sum
        if (localFeeDialog.isNew && updatedFeeArrayLocal?.length === 0) {
          if (localFeeDialog.oldToValue === '' && localFeeDialog.oldSelectedFeeType === '') {
            availableCurrencyLocal.forEach((fee, index) => {
              const entity = {
                ...comexBankFeeForm,
                ...values,
                fromTo: localFeeDialog.checkedToValue,
                feeType: localFeeDialog.selectedFeeType,
                amount: parseAmountValue(formStateFeeLocal[index]?.amount),
                currencyId: formStateFeeLocal[index]?.currencyId,
                bank: bankEntity,
                bankId: props.match.params.id,
                commodityType: 'Local',
              };
              const bankFeeLog = {
                ...comexBankFeeForm,
                ...values,
                fromTo: localFeeDialog.checkedToValue,
                feeType: localFeeDialog.selectedFeeType,
                amount: parseAmountValue(formStateFeeLocal[index]?.amount),
                currencyId: formStateFeeLocal[index]?.currencyId,
                bank: bankEntity,
                bankId: props.match.params.id,
                status: 'CREATE',
                commodityType: 'Local',
              };
              dispatchPromises.push(dispatch(createComexBankFee(entity)));
              dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
            });
          }
        } else {
          // edit fee type
          if (localFeeDialog.oldSelectedFeeType !== '' && localFeeDialog.oldSelectedFeeType !== localFeeDialog.selectedFeeType) {
            const newRows = formStateFeeLocal?.slice(1, formStateFeeLocal?.length);
            newRows?.forEach((fee, index) => {
              const entity = {
                ...comexBankFeeForm,
                ...values,
                id: null,
                feeType: localFeeDialog.selectedFeeType,
                fromTo: localFeeDialog.checkedToValue,
                amount: parseAmountValue(formStateFeeLocal[index + 1]?.amount),
                currencyId: formStateFeeLocal[index + 1]?.currencyId,
                bank: bankEntity,
                bankId: props.match.params.id,
                commodityType: 'Local',
              };
              const bankFeeLogOtherEntities = {
                ...comexBankFeeForm,
                ...values,
                id: null,
                feeType: localFeeDialog.selectedFeeType,
                fromTo: localFeeDialog.checkedToValue,
                amount: parseAmountValue(formStateFeeLocal[index + 1]?.amount),
                currencyId: formStateFeeLocal[index + 1]?.currencyId,
                bank: bankEntity,
                bankId: props.match.params.id,
                status: 'CREATE',
                commodityType: 'Local',
              };
              dispatchPromises.push(dispatch(createComexBankFee(entity)));
              dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLogOtherEntities)));
            });

            const foundItem = comexBankFeeList?.find(item => item?.id?.toString() === localFeeDialog.bankFeeId);
            const firstEntity = {
              ...foundItem,
              ...values,
              id: foundItem?.id,
              feeType: localFeeDialog.selectedFeeType,
              fromTo: localFeeDialog.checkedToValue,
              amount: parseAmountValue(formStateFeeLocal[0]?.amount),
              currencyId: formStateFeeLocal[0]?.currencyId,
              bank: bankEntity,
              bankId: props.match.params.id,
              commodityType: 'Local',
            };
            const bankFeeLogfirstEntity = {
              ...comexBankFeeForm,
              ...values,
              id: null,
              feeType: localFeeDialog.selectedFeeType,
              fromTo: localFeeDialog.checkedToValue,
              amount: parseAmountValue(formStateFeeLocal[0]?.amount),
              currencyId: formStateFeeLocal[0]?.currencyId,
              bank: bankEntity,
              bankId: props.match.params.id,
              status: 'UPDATE',
              commodityType: 'Local',
            };
            dispatchPromises.push(dispatch(updateComexBankFee(firstEntity)));
            dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLogfirstEntity)));
          }

          // edit to value - lump sum
          if (localFeeDialog.oldToValue !== '' && localFeeDialog.oldToValue !== localFeeDialog.toValue) {
            formStateFeeLocal.forEach((item, index) => {
              const entity = {
                ...item,
                ...values,
                id: item?.id,
                fromTo: localFeeDialog.checkedToValue,
                feeType: item?.feeType,
                amount: item?.amount ? parseFloat(String(item?.amount).replace(/,/g, '')) : 0,
                bank: bankEntity,
                bankId: props.match.params.id,
                currencyId: item?.currencyId,
                commodityType: 'Local',
              };
              const bankFeeLog = {
                ...comexBankFeeForm,
                ...values,
                id: null,
                fromTo: localFeeDialog.checkedToValue,
                feeType: item?.feeType,
                amount: item?.amount ? parseFloat(String(item?.amount).replace(/,/g, '')) : 0,
                status: 'UPDATE',
                bank: bankEntity,
                bankId: props.match.params.id,
                currencyId: item?.currencyId,
                commodityType: 'Local',
              };
              dispatchPromises.push(dispatch(updateComexBankFee(entity)));
              dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
            });
          }

          // edit amount - lump sum (support multi-currency update)
          if (updatedFeeArrayLocal?.length > 0 || modifiedFeesLocal.size > 0) {
            // Process tracked modifications from Map
            if (modifiedFeesLocal.size > 0) {
              modifiedFeesLocal.forEach((newAmount, currencyId) => {
                const foundItem = comexBankFeeList?.find(
                  item => item?.currencyId === currencyId && item?.fromTo === localFeeDialog.checkedToValue && item?.feeType === 'Lump Sum'
                );
                if (foundItem) {
                  const cleanedAmount = Number(parseFloat(String(newAmount).replace(/,/g, '')).toFixed(2));
                  const entity = {
                    ...foundItem,
                    ...values,
                    id: foundItem?.id,
                    currencyId: Number(foundItem?.currencyId),
                    feeType: foundItem?.feeType,
                    fromTo: localFeeDialog.checkedToValue,
                    amount: cleanedAmount,
                    bank: bankEntity,
                    bankId: props.match.params.id,
                    commodityType: 'Local',
                  };
                  const bankFeeLog = {
                    ...comexBankFeeForm,
                    ...values,
                    fromTo: localFeeDialog.checkedToValue,
                    feeType: foundItem?.feeType,
                    amount: cleanedAmount,
                    currencyId: Number(foundItem?.currencyId),
                    id: null,
                    bank: bankEntity,
                    bankId: props.match.params.id,
                    status: 'UPDATE',
                    commodityType: 'Local',
                  };
                  dispatchPromises.push(dispatch(updateComexBankFee(entity)));
                  dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
                }
              });
            } else {
              // Fallback to old logic if no modifications tracked
              updatedFeeArrayLocal?.forEach((value, index) => {
                const foundItem = comexBankFeeList?.find(item => item?.id?.toString() === value?.id);
                if (foundItem) {
                  const entity = {
                    ...foundItem,
                    ...values,
                    id: foundItem?.id,
                    currencyId: Number(foundItem?.currencyId),
                    feeType: foundItem?.feeType,
                    fromTo: localFeeDialog.checkedToValue,
                    amount: Number(parseFloat(String(value?.newAmount).replace(/,/g, '')).toFixed(2)),
                    bank: bankEntity,
                    bankId: props.match.params.id,
                    commodityType: 'Local',
                  };
                  const bankFeeLog = {
                    ...comexBankFeeForm,
                    ...values,
                    fromTo: localFeeDialog.checkedToValue,
                    feeType: foundItem?.feeType,
                    amount: Number(parseFloat(String(value?.newAmount).replace(/,/g, '')).toFixed(2)),
                    currencyId: Number(foundItem?.currencyId),
                    id: null,
                    bank: bankEntity,
                    bankId: props.match.params.id,
                    status: 'UPDATE',
                    commodityType: 'Local',
                  };
                  dispatchPromises.push(dispatch(updateComexBankFee(entity)));
                  dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
                }
              });
            }
          }
        }
        // Percentage
      } else if (localFeeDialog.selectedFeeType === 'Percentage') {
        // new - percentage
        if (localFeeDialog.isNew && localFeeDialog.oldAmount === '') {
          const entity = {
            ...comexBankFeeForm,
            ...values,
            fromTo: localFeeDialog.checkedToValue,
            feeType: localFeeDialog.selectedFeeType,
            amount: localFeeDialog.checkedAmount,
            bank: bankEntity,
            bankId: props.match.params.id,
            commodityType: 'Local',
          };
          const bankFeeLog = {
            ...comexBankFeeForm,
            ...values,
            fromTo: localFeeDialog.checkedToValue,
            feeType: localFeeDialog.selectedFeeType,
            amount: localFeeDialog.checkedAmount,
            bank: bankEntity,
            bankId: props.match.params.id,
            status: 'CREATE',
            commodityType: 'Local',
          };
          dispatchPromises.push(dispatch(createComexBankFee(entity)));
          dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
          // edit amount - percentage
        } else {
          const foundItem = comexBankFeeList?.find(item => item?.id?.toString() === localFeeDialog.bankFeeId);

          // edit fee type
          if (foundItem?.feeType === 'Lump Sum') {
            const entity = {
              ...foundItem,
              ...values,
              id: foundItem?.id,
              fromTo: localFeeDialog.checkedToValue,
              feeType: localFeeDialog.selectedFeeType,
              amount: localFeeDialog.checkedAmount,
              bank: bankEntity,
              bankId: foundItem?.bankId,
              currencyId: null,
              commodityType: 'Local',
            };
            const bankFeeLog = {
              ...comexBankFeeForm,
              ...values,
              fromTo: localFeeDialog.checkedToValue,
              feeType: localFeeDialog.selectedFeeType,
              amount: localFeeDialog.checkedAmount,
              id: null,
              bank: bankEntity,
              bankId: props.match.params.id,
              status: 'UPDATE',
              currencyId: null,
              commodityType: 'Local',
            };
            dispatchPromises.push(dispatch(updateComexBankFee(entity)));
            dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));

            const filteredData = comexBankFeeList?.filter(
              item => item?.fromTo === localFeeDialog.checkedToValue && item?.id?.toString() !== localFeeDialog.bankFeeId
            );
            filteredData?.map(item => {
              const comexBankFeelog = {
                ...comexBankFeeForm,
                ...values,
                id: null,
                fromTo: item.fromTo,
                status: 'DELETE',
                amount: item?.amount,
                bank: bankEntity,
                bankId: props.match.params.id,
                currencyId: item?.currencyId,
                commodityType: 'Local',
              };
              dispatchPromises.push(dispatch(createComexBankFeeLog(comexBankFeelog)));
              dispatchPromises.push(
                dispatch(deleteEntityFromBank({ id: item?.id, bankId: bankEntity?.id, fromTo: localFeeDialog.checkedToValue }))
              );
            });
          } else {
            const entity = {
              ...foundItem,
              ...values,
              id: Number(localFeeDialog.bankFeeId),
              fromTo: localFeeDialog.checkedToValue,
              amount: localFeeDialog.checkedAmount,
              bank: bankEntity,
              bankId: props.match.params.id,
              feeType: localFeeDialog.selectedFeeType,
              currencyId: null,
              commodityType: 'Local',
            };
            const bankFeeLog = {
              ...foundItem,
              ...values,
              fromTo: localFeeDialog.checkedToValue,
              feeType: localFeeDialog.selectedFeeType,
              amount: localFeeDialog.checkedAmount,
              id: null,
              bank: bankEntity,
              bankId: props.match.params.id,
              status: 'UPDATE',
              commodityType: 'Local',
            };
            dispatchPromises.push(dispatch(updateComexBankFee(entity)));
            dispatchPromises.push(dispatch(createComexBankFeeLog(bankFeeLog)));
          }
        }
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      await Promise.all(dispatchPromises);
      setIsPending(false);
      handleCloseLocal();
      // dispatch(getFeeListByBankId(props.match.params.id));
      dispatch(
        getFeeListByBankIdAndCommodityType({
          bankId: props.match.params.id,
          commodityType: 'Local',
        })
      );
    }
  };

  const branchExists = branchList?.find(branch => branch?.name?.toLowerCase() === branchNameInput?.toLowerCase()) !== undefined;

  const handleBranchUpdate = () => {
    const updateBranch = { ...selectedBranchEntity, name: branchName };
    dispatch(partialUpdateEntity(updateBranch));
    setOpenBranchEdit(false);
    setBranchValue(branchName);
  };

  const handleCreateBranch = name => {
    if (branchNameInput === '') {
      setIsBranchEmpty(true);
      setOpenBranchCreate(true);
    } else {
      if (branchExists) {
        setIsBranchExists(true);
        setOpenBranchCreate(true);
      } else {
        const entity = {
          name,
          managerApproval: false,
          escalateApproval: false,
          customerApproval: false,
          bank: bankEntity,
        };
        dispatch(createEntity(entity));
        setOpenBranchCreate(false);
        setBranchNameInput('');
        setIsBranchEmpty(false);
        setIsBranchExists(false);
      }
    }
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'rgba(255,255,255,0)',
      color: theme.palette.common.white,
      fontWeight: 'bold',
      letterSpacing: 1,
      textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
    },
  }));

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const theme = useTheme();
  const [branchValue, setBranchValue] = React.useState('');
  const [idValue, setIdValue] = React.useState('');
  const [active, setActive] = React.useState(false);
  const [areaManagerId, setAreaManagerId] = React.useState('');
  const handleChange = event => {
    const selectedBranch = event.target.value;
    const branchArray = selectedBranch.split('|');
    const name = String(branchArray[0]);
    const id = String(branchArray[1]);
    setAreaManagerId(String(branchArray[2]));
    dispatch(getBranch(Number(id)));
    const selectValue = JSON.parse(window.localStorage.getItem('selectedBranch'));
    setActive(true);
    setBranchValue(name);
    setIdValue(id);
    window.localStorage.setItem('selectedBranch', JSON.stringify(name));
  };

  const [switchState, setSwitchState] = React.useState({
    required: true,
    notRequired: false,
  });
  const handleSwitchManager = branch => () =>
    !branch.managerApproval
      ? dispatch(
          updateEntity({
            ...branch,
            managerApproval: true,
          })
        )
      : dispatch(
          updateEntity({
            ...branch,
            managerApproval: false,
            escalateApproval: false,
          })
        );
  const handleSwitchEscalate = branch => () =>
    branch.managerApproval &&
    dispatch(
      updateEntity({
        ...branch,
        escalateApproval: !branch.escalateApproval,
      })
    );
  const handleSwitchCustomer = branch => () =>
    dispatch(
      updateEntity({
        ...branch,
        customerApproval: !branch.customerApproval,
      })
    );

  const handleSwitchAllowToSellInternationalCommodity = branch => () =>
    dispatch(
      updateEntity({
        ...branch,
        sellApprovalInternationalCommodity: !branch.sellApprovalInternationalCommodity,
      })
    );

  const handleSwitchAllowToSellLocalCommodity = branch => () =>
    dispatch(
      updateEntity({
        ...branch,
        sellApprovalLocalCommodity: !branch.sellApprovalLocalCommodity,
      })
    );

  const handleApiSettingsCollapse = () => {
    setApiSettingsCollapse(prev => !prev);
  };

  const handleValueSellConfirmationEndpoint = event => {
    const changeSellConfirmationEndpoint = event.target.value;
    setValueSellConfirmationEndpoint(changeSellConfirmationEndpoint);
  };

  const handleValueVendorName = event => {
    const changeVendorName = event.target.value;
    setValueVendorName(changeVendorName);
  };

  const handleValueVendorCif = event => {
    const changeVendorCif = event.target.value;
    setValueVendorCif(changeVendorCif);
  };

  const handleApiSettings = async () => {
    const entity = {
      ...bankApiSettingEntity,
      bankId: bankEntity?.id,
      sellConfirmationEndpoint: valueSellConfirmationEndpoint,
      vendorName: valueVendorName,
      vendorCif: valueVendorCif,
    };

    await dispatch(createBankApiSetting(entity))
      .then(res => {
        const data = (res.payload as { data: { sellConfirmationEndpoint?: string; vendorName?: string; vendorCif?: string } })?.data;
        setValueSellConfirmationEndpoint(data?.sellConfirmationEndpoint || '');
        setValueVendorName(data?.vendorName || '');
        setValueVendorCif(data?.vendorCif || '');
      })
      .catch(error => {
        setValueSellConfirmationEndpoint('');
        setValueVendorName('');
        setValueVendorCif('');
      });
  };

  const [reportSettingsState, setReportSettingsState] = React.useState({
    bankStaffRole: bankEntity?.reportForBankStaff,
    branchManagerRole: bankEntity?.reportForBranchManager,
    areaManagerRole: bankEntity?.reportForAreaManager,
    suppliersDepartmentRole: true,
    operationsDepartmentRole: true,
    bankManagerRole: bankEntity?.reportForBankManager,
  });

  const handleReportSettingsChange = event => {
    setReportSettingsState({
      ...reportSettingsState,
      [event.target.name]: event.target.checked,
    });
  };

  const [reportSwitchState, setReportSwitchState] = React.useState({
    available: true,
    unavailable: false,
  });

  const handleBankStaffReport = () => {
    const updateBankStaffReport = { ...bankEntity, reportForBankStaff: !bankEntity.reportForBankStaff };
    dispatch(updateBank(updateBankStaffReport));
  };

  const handleBranchManagerReport = () => {
    const updateBranchManagerReport = { ...bankEntity, reportForBranchManager: !bankEntity.reportForBranchManager };
    dispatch(updateBank(updateBranchManagerReport));
  };

  const handleAreaManagerReport = () => {
    const updateAreaManagerReport = { ...bankEntity, reportForAreaManager: !bankEntity.reportForAreaManager };
    dispatch(updateBank(updateAreaManagerReport));
  };

  const handleBankManagerReport = () => {
    const updateBankManagerReport = { ...bankEntity, reportForBankManager: !bankEntity.reportForBankManager };
    dispatch(updateBank(updateBankManagerReport));
  };

  const handleAuditorReport = () => {
    const updateAuditorReport = { ...bankEntity, reportForAuditor: !bankEntity.reportForAuditor };
    dispatch(updateBank(updateAuditorReport));
  };

  useEffect(() => {
    if (areaManagerId !== '') {
      if (account?.authorities.includes(AUTHORITIES.ADMIN)) dispatch(getUserByIdAsAdmin(+areaManagerId));
      else dispatch(getUserByIdAsOtherRoles(+areaManagerId));
    }
  }, [areaManagerId]);

  useEffect(() => {
    idValue !== '' && dispatch(getAccountsByBranchId(+idValue));
  }, [branchList, idValue]);
  useEffect(() => {
    setBranchName(branchValue);
  }, [branchValue]);
  selectedBranchEntity = branchList?.find(branch => branch.id === +idValue);
  const useStyles = makeStyles(() =>
    createStyles({
      dialogArabic: {
        margin: 0,
        marginLeft: '40px',
      },
      avatar: {
        width: '40px',
        height: '40px',
        fontSize: '16px',
        [theme.breakpoints.down('xs')]: {
          width: '30px',
          height: '30px',
          fontSize: '12px',
        },
      },
      listAvartarItem: {
        marginRight: '0px',
        [theme.breakpoints.down('xs')]: {
          marginLeft: '12px',
        },
      },
    })
  );

  const imgFromDb = bankEntity?.imgURL;
  const imgStringToNumber = imgFromDb?.split(',').map(i => Number(i));
  const decodedImgString = String.fromCharCode.apply(null, imgStringToNumber);
  const imageFromS3 = `https://${s3BucketName}.s3.eu-west-3.amazonaws.com/bankLogo/${bankEntity?.imgURL}`

  const classes = useStyles();
  let responsiveFont = createTheme();
  responsiveFont = responsiveFontSizes(responsiveFont);

  useEffect(() => {
    setLoadingSpinner(false);
    setTimeout(() => {
      setLoadingSpinner(true);
    }, 2500);
  }, []);

  function bankLogo() {
    if (bankEntity?.imgURL !== null && bankEntity?.imgURL !== undefined && s3BucketName) {
      return <img className="bank-img" src={imageFromS3} alt="bankLogo" />;
    } else if (bankEntity?.imgURL === null) {
      return <img className="bank-img" src="content/images/bankLogoDefault.png" alt="bankLogo" />;
    } else if (loadingSpinner === false) {
      return (
        <div hidden={loadingSpinner}>
          <img src="../../content/images/loading.gif" style={{ opacity: '40%', width: '60%', height: 'auto' }} hidden={loadingSpinner} />
        </div>
      );
    }
  }

  useEffect(() => {
    if (bankEntity && bankEntity.currencyId) {
      setSelectedCurrency(bankEntity.currencyId);
      setSelectedCurrencyLocal(bankEntity.currencyId);
    }
  }, [bankEntity]);

  useEffect(() => {
    if (internationalFeeDialog.oldSelectedFeeType !== internationalFeeDialog.selectedFeeType) {
      setUpdatedFeeArray([]);
    } else {
      setUpdatedFeeArray(checkArrayDifferences(oldFormStateFee, formStateFee));
    }
  }, [internationalFeeDialog.oldSelectedFeeType, internationalFeeDialog.selectedFeeType, oldFormStateFee, formStateFee]);

  useEffect(() => {
    if (localFeeDialog.oldSelectedFeeType !== localFeeDialog.selectedFeeType) {
      setUpdatedFeeArrayLocal([]);
    } else {
      setUpdatedFeeArrayLocal(checkArrayDifferences(oldFormStateFeeLocal, formStateFeeLocal));
    }
  }, [localFeeDialog.oldSelectedFeeType, localFeeDialog.selectedFeeType, oldFormStateFeeLocal, formStateFeeLocal]);

  useEffect(() => {
    if (oldFormStateCommission?.length && formStateCommission?.length) {
      setUpdatedCommissionArray(checkArrayDifferences(oldFormStateCommission, formStateCommission));
    }
  }, [oldFormStateCommission, formStateCommission]);

  useEffect(() => {
    if (oldFormStateCommissionLocal?.length && formStateCommissionLocal?.length) {
      setUpdatedCommissionArrayLocal(checkArrayDifferences(oldFormStateCommissionLocal, formStateCommissionLocal));
    }
  }, [oldFormStateCommissionLocal, formStateCommissionLocal]);

  useEffect(() => {
    // filtered list commission
    const filteredCommissionList = comexBankFeeList?.filter(
      c => c?.currencyId?.toLocaleString() === selectedCurrency.toLocaleString() && c?.feeType === 'commission'
    );
    setFilteredComexBankCommissionList(filteredCommissionList);

    const filteredCommissionListLocal = comexBankFeeList?.filter(
      c => c?.currencyId?.toLocaleString() === selectedCurrencyLocal.toLocaleString() && c?.feeType === 'commission'
    );
    setFilteredComexBankCommissionListLocal(filteredCommissionListLocal);

    // filtered list fee
    const filteredFeeList = comexBankFeeList?.filter(
      c => (c?.currencyId?.toLocaleString() === selectedCurrency.toLocaleString() || c?.currencyId === null) && c?.feeType !== 'commission'
    );
    setFilteredComexBankFeeList(filteredFeeList);

    const filteredFeeListLocal = comexBankFeeList?.filter(
      c =>
        (c?.currencyId?.toLocaleString() === selectedCurrencyLocal.toLocaleString() || c?.currencyId === null) &&
        c?.feeType !== 'commission'
    );
    setFilteredComexBankFeeListLocal(filteredFeeListLocal);

    // grouped all currency by fromTo value
    const newGroupedData = newComexBankFeeList?.reduce((acc, current) => {
      if (current?.currencyId === null) {
        acc?.push({ fromTo: current?.fromTo, fee: [{ id: current?.id, amount: current?.amount, currencyId: null }] });
      } else {
        const index = acc?.findIndex(group => group?.fromTo === current?.fromTo);
        if (index === -1) {
          acc?.push({ fromTo: current?.fromTo, fee: [{ id: current?.id, amount: current?.amount, currencyId: current?.currencyId }] });
        } else {
          acc[index]?.fee?.push({ id: current?.id, amount: current?.amount, currencyId: current?.currencyId });
        }
      }
      return acc;
    }, []);

    const newGroupedDataLocal = newComexBankFeeList?.reduce((acc, current) => {
      if (current?.currencyId === null) {
        acc?.push({ fromTo: current?.fromTo, fee: [{ id: current?.id, amount: current?.amount, currencyId: null }] });
      } else {
        const index = acc?.findIndex(group => group?.fromTo === current?.fromTo);
        if (index === -1) {
          acc?.push({ fromTo: current?.fromTo, fee: [{ id: current?.id, amount: current?.amount, currencyId: current?.currencyId }] });
        } else {
          acc[index]?.fee?.push({ id: current?.id, amount: current?.amount, currencyId: current?.currencyId });
        }
      }
      return acc;
    }, []);

    setGroupedData(newGroupedData);
    setGroupedDataLocal(newGroupedDataLocal);
  }, [selectedCurrency, selectedCurrencyLocal, comexBankFeeList]);

  const handleChangeCurrencyDropdown = event => {
    setSelectedCurrency(event.target.value);
  };

  const handleChangeCurrencyDropdownLocal = event => {
    setSelectedCurrencyLocal(event.target.value);
  };

  const handleChangeFeeAllCurrency = useCallback((id: string) => {
    const itemIndex = availableCurrency.findIndex(item => item.id === id);
    return event => {
      const value = toEnglishDigits(event.target.value);

      setFormStateFee(prev => {
        const exists = prev.some(fee => fee.currencyId === id);
        if (exists) {
          return prev.map(fee => (fee.currencyId === id ? { ...fee, amount: value } : fee));
        } else {
          return [...prev, { currencyId: id, amount: value }];
        }
      });

      setFormStateCommission(prev => {
        const exists = prev.some(commission => commission.currencyId === id);
        if (exists) {
          return prev.map(commission => (commission.currencyId === id ? { ...commission, amount: value } : commission));
        } else {
          return [...prev, { currencyId: id, amount: value }];
        }
      });
    };
  }, []);

  const handleChangeFeeAllCurrencyLocal = useCallback((id: string) => {
    return event => {
      const value = toEnglishDigits(event.target.value);

      setFormStateFeeLocal(prev => {
        const exists = prev.some(fee => fee.currencyId === id);
        if (exists) {
          return prev.map(fee => (fee.currencyId === id ? { ...fee, amount: value } : fee));
        } else {
          return [...prev, { currencyId: id, amount: value }];
        }
      });

      setFormStateCommissionLocal(prev => {
        const exists = prev.some(commission => commission.currencyId === id);
        if (exists) {
          return prev.map(commission => (commission.currencyId === id ? { ...commission, amount: value } : commission));
        } else {
          return [...prev, { currencyId: id, amount: value }];
        }
      });
    };
  }, []);

  const handleDigits = useCallback(
    (event, id) => {
      const value = toEnglishDigits(event.target.value);
      const formattedValue = formatGroupedAmount(value, 2);

      // Track this currency as modified for fees
      if (updateCommission === true) {
        setModifiedFees(prev => {
          const newMap = new Map(prev);
          if (formattedValue && formattedValue !== '0') {
            newMap.set(id, formattedValue);
          } else {
            newMap.delete(id);
          }
          return newMap;
        });
      } else {
        // Track for commissions
        setModifiedCommissions(prev => {
          const newMap = new Map(prev);
          if (formattedValue && formattedValue !== '0') {
            newMap.set(id, formattedValue);
          } else {
            newMap.delete(id);
          }
          return newMap;
        });
      }

      setFormStateFee(prev => {
        const exists = prev.some(fee => fee.currencyId === id);
        if (exists) {
          return prev.map(fee => (fee.currencyId === id ? { ...fee, amount: formattedValue } : fee));
        } else {
          return [...prev, { currencyId: id, amount: formattedValue }];
        }
      });

      setFormStateCommission(prev => {
        const exists = prev.some(commission => commission.currencyId === id);
        if (exists) {
          return prev.map(commission => (commission.currencyId === id ? { ...commission, amount: formattedValue } : commission));
        } else {
          return [...prev, { currencyId: id, amount: formattedValue }];
        }
      });
    },
    [updateCommission]
  );

  const handleDigitsLocal = useCallback(
    (event, id) => {
      const value = toEnglishDigits(event.target.value);
      const formattedValue = formatGroupedAmount(value, 2);

      // Track this currency as modified for fees
      if (updateCommissionLocal === true) {
        setModifiedFeesLocal(prev => {
          const newMap = new Map(prev);
          if (formattedValue && formattedValue !== '0') {
            newMap.set(id, formattedValue);
          } else {
            newMap.delete(id);
          }
          return newMap;
        });
      } else {
        // Track for commissions
        setModifiedCommissionsLocal(prev => {
          const newMap = new Map(prev);
          if (formattedValue && formattedValue !== '0') {
            newMap.set(id, formattedValue);
          } else {
            newMap.delete(id);
          }
          return newMap;
        });
      }

      setFormStateFeeLocal(prev => {
        const exists = prev.some(fee => fee.currencyId === id);
        if (exists) {
          return prev.map(fee => (fee.currencyId === id ? { ...fee, amount: formattedValue } : fee));
        } else {
          return [...prev, { currencyId: id, amount: formattedValue }];
        }
      });

      setFormStateCommissionLocal(prev => {
        const exists = prev.some(commission => commission.currencyId === id);
        if (exists) {
          return prev.map(commission => (commission.currencyId === id ? { ...commission, amount: formattedValue } : commission));
        } else {
          return [...prev, { currencyId: id, amount: formattedValue }];
        }
      });
    },
    [updateCommissionLocal]
  );

  useEffect(() => {
    if (isNew) {
      filterUniqueFromAmountFee();
      filterUniqueFromAmountFeeLocal();
    }
  }, [comexBankFeeList]);

  const filterUniqueFromAmountFee = () => {
    const onlyFeeList = comexBankFeeList?.filter(c => c?.feeType !== 'commission');
    const unique = onlyFeeList?.reduce((uniqueItems, item) => {
      if (!uniqueItems?.some(i => i?.fromTo === item?.fromTo)) {
        uniqueItems?.push(item);
      }
      return uniqueItems;
    }, []);

    setUniqueFromAmountFee(unique);
  };

  const filterUniqueFromAmountFeeLocal = () => {
    const onlyFeeList = comexBankFeeList?.filter(c => c?.feeType !== 'commission');
    const unique = onlyFeeList?.reduce((uniqueItems, item) => {
      if (!uniqueItems?.some(i => i?.fromTo === item?.fromTo)) {
        uniqueItems?.push(item);
      }
      return uniqueItems;
    }, []);

    setUniqueFromAmountFeeLocal(unique);
  };

  function findCurrencyName(entity) {
    const find = availableCurrency?.find(c => c?.id === entity);
    return find?.name;
  }

  function findCurrencyNameLocal(entity) {
    const find = availableCurrencyLocal?.find(c => c?.id === entity);
    return find?.name;
  }

  const feeAllCurrencyForm = useCallback(() => {
    return (
      <TableContainer sx={{ maxHeight: 160 }}>
        <Table sx={{ minWidth: 400, '& th, & td': { border: 0 } }} size="small">
          <TableBody>
            {availableCurrency?.map((item, index) => {
              const matchedFee = formStateFee.find(fee => fee.currencyId === item.id);
              const matchedCommission = formStateCommission.find(commission => commission.currencyId === item.id);

              return (
                <TableRow key={item?.id}>
                  <TableCell width="20%" component="th" scope="row" align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}>
                    {item?.name}
                  </TableCell>
                  <StyledTableCell />
                  <TableCell align="right">
                    {updateCommission === true ? (
                      <Input
                        style={{ width: '100%' }}
                        type="text"
                        placeholder="0"
                        onChange={event => {
                          handleChangeFeeAllCurrency(item?.id)(event);
                          handleDigits(event, item?.id);
                        }}
                        value={matchedFee ? matchedFee.amount : ''}
                      />
                    ) : (
                      <Input
                        style={{ width: '100%' }}
                        type="text"
                        placeholder="0"
                        onChange={event => {
                          handleChangeFeeAllCurrency(item?.id)(event);
                          handleDigits(event, item?.id);
                        }}
                        value={matchedCommission ? matchedCommission.amount : ''}
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [availableCurrency, formStateFee, formStateCommission, updateCommission, handleChangeFeeAllCurrency, handleDigits]);

  const feeAllCurrencyFormLocal = useCallback(() => {
    return (
      <TableContainer sx={{ maxHeight: 160 }}>
        <Table sx={{ minWidth: 400, '& th, & td': { border: 0 } }} size="small">
          <TableBody>
            {availableCurrencyLocal?.map((item, index) => {
              const matchedFee = formStateFeeLocal.find(fee => fee.currencyId === item.id);
              const matchedCommission = formStateCommissionLocal.find(commission => commission.currencyId === item.id);

              return (
                <TableRow key={item?.id}>
                  <TableCell width="20%" component="th" scope="row" align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}>
                    {item?.name}
                  </TableCell>
                  <StyledTableCell />
                  <TableCell align="right">
                    {updateCommissionLocal === true ? (
                      <Input
                        style={{ width: '100%' }}
                        type="text"
                        placeholder="0"
                        onChange={event => {
                          handleChangeFeeAllCurrencyLocal(item?.id)(event);
                          handleDigitsLocal(event, item?.id);
                        }}
                        value={matchedFee ? matchedFee.amount : ''}
                      />
                    ) : (
                      <Input
                        style={{ width: '100%' }}
                        type="text"
                        placeholder="0"
                        onChange={event => {
                          handleChangeFeeAllCurrencyLocal(item?.id)(event);
                          handleDigitsLocal(event, item?.id);
                        }}
                        value={matchedCommission ? matchedCommission.amount : ''}
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [
    availableCurrencyLocal,
    formStateFeeLocal,
    formStateCommissionLocal,
    updateCommissionLocal,
    handleChangeFeeAllCurrencyLocal,
    handleDigitsLocal,
  ]);

  function feeAmountFieldInternational() {
    if (internationalFeeDialog.selectedFeeType === 'Lump Sum') {
      return feeAllCurrencyForm();
    } else {
      return (
        <ValidatedField
          register={register}
          error={errors?.amount}
          id="comex-bank-fee-amount"
          name="amount"
          data-cy="amount"
          type="text"
          onChange={handleAmount}
          value={internationalFeeDialog.amount}
          validate={{
            required: { value: true, message: translate('entity.validation.required') },
            validate: v => isNumber(internationalFeeDialog.checkedAmount) || translate('entity.validation.number'),
          }}
        />
      );
    }
  }

  function feeAmountFieldLocal() {
    if (localFeeDialog.selectedFeeType === 'Lump Sum') {
      return feeAllCurrencyFormLocal();
    } else {
      return (
        <ValidatedField
          register={register}
          error={errors?.amount}
          id="comex-bank-fee-amount-local"
          name="amount"
          data-cy="amount"
          type="text"
          onChange={handleAmountLocal}
          value={localFeeDialog.amount}
          validate={{
            required: { value: true, message: translate('entity.validation.required') },
            validate: v => isNumber(localFeeDialog.checkedAmount) || translate('entity.validation.number'),
          }}
        />
      );
    }
  }

  const isUserAuthorizedToEdit = userRoleAccessList.length === 0 || userRoleAccessList.some(role => role.bankId === bankEntity?.id);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const renderCommissionAndFeeSectionInternational = () => {
    return (
      <div className="collapse-section">
        <Grid container className="align-items-center">
          <Grid item xs={10} sm={11} md={11.5}>
            <Typography variant="h5" component="div" data-cy="bankFeeHeading">
              {translate('comexApp.bank.details.commissionAndFee')}
            </Typography>
          </Grid>
          <Grid item xs={2} sm={1} md={0.5}>
            <IconButton aria-label="collapse" onClick={handleFeeCollapse}>
              {!feeCollapse ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
            </IconButton>
          </Grid>
        </Grid>
        <Collapse in={!feeCollapse}>
          <br />
          <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <div>
              <FormControl sx={{ width: { md: 300, xs: 280 }, display: 'flex', justifyContent: 'flex-start' }}>
                <Input type="select" width={'80%'} onChange={handleChangeCurrencyDropdown} value={selectedCurrency}>
                  {availableCurrency?.map((c, index) => {
                    return (
                      <option key={index} value={c?.id}>
                        {c?.name}
                      </option>
                    );
                  })}
                </Input>
              </FormControl>
            </div>
          </Box>
          <Paper className="paper-table my-4">
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table className="fee-table" aria-label="sticky table">
                <TableHead
                  className={
                    !isUserAuthorizedToEdit ? 'disable-table-bank' : bankEntity?.commission ? 'enhanced-table-bank' : 'disable-table-bank'
                  }
                  id="commissionTable"
                >
                  <TableRow>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.active" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.commissionForEachAmount" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.commissionAmount" />
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredComexBankCommissionList &&
                    filteredComexBankCommissionList.map((item, i) => (
                      <TableRow key={item.id}>
                        <StyledTableCell>
                          <Checkbox size="small" checked={commissionData} onChange={handleCommission} disabled={!isUserAuthorizedToEdit} />
                        </StyledTableCell>
                        <StyledTableCell>
                          {item?.fromTo?.toLocaleString()}
                          {/* <Input */}
                          {/*   id="commissionForEach" */}
                          {/*   type="text" */}
                          {/*   value={commissionForEachAmt} */}
                          {/*   onChange={handleCommissionForEachAmount} */}
                          {/*   disabled={updateCommission} */}
                          {/*   autoFocus={isCommissionForEachFieldClicked} */}
                          {/*   /> */}
                        </StyledTableCell>

                        <StyledTableCell>
                          {item?.amount?.toLocaleString() + ' ' + findCurrencyName(item?.currencyId)}
                          {/* {commissionAmt} */}
                          {/* <Input */}
                          {/*   id="commissionAmount" */}
                          {/*   type="text" */}
                          {/*   value={commissionAmt} */}
                          {/*   onChange={handleCommissionAmount} */}
                          {/*   disabled={updateCommission} */}
                          {/*   autoFocus={isCommissionAmountFieldClicked} */}
                          {/*   /> */}
                        </StyledTableCell>
                        <StyledTableCell
                          hidden={
                            account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                            !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
                          }
                        >
                          <div className="btn-group flex-btn-group-container" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Tooltip title={translate('comexApp.bank.details.table.editIcon')}>
                              <span>
                                <IconButton
                                  className="px-4"
                                  aria-label="edit"
                                  size="small"
                                  onClick={() => handleClickOpenCommission(item?.id)}
                                  value={item?.id}
                                  disabled={updatingBank || updateCommission || !isUserAuthorizedToEdit}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title={translate('comexApp.bank.details.table.deleteIcon')}>
                              <span>
                                <IconButton
                                  className="px-4"
                                  aria-label="delete"
                                  size="small"
                                  color="error"
                                  onClick={() => setOpenDelete(item.id)}
                                  disabled={updatingBank || updateCommission || !isUserAuthorizedToEdit}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </div>
                        </StyledTableCell>
                        {/* <StyledTableCell> */}
                        {/*   <Button onClick={updateCommissionBank} color="primary" type="button" disabled={updatingBank || updateCommission}> */}
                        {/*     <Translate contentKey='comexApp.bank.details.update' /> */}
                        {/*   </Button> */}
                        {/* </StyledTableCell> */}
                      </TableRow>
                    ))}
                  {filteredComexBankCommissionList?.length === 0 && (
                    <TableRow>
                      <StyledTableCell>
                        <Checkbox size="small" checked={commissionData} onChange={handleCommission} />
                      </StyledTableCell>
                      <StyledTableCell>0</StyledTableCell>
                      <StyledTableCell>0</StyledTableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              color="primary"
              disabled={updatingBank || updateCommission || filteredComexBankCommissionList.length !== 0 || !isUserAuthorizedToEdit}
              onClick={() => handleClickOpenCommission(0)}
              value={0}
              hidden={
                account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) && !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
              }
            >
              <FontAwesomeIcon icon="plus" /> <Translate contentKey="comexApp.bank.details.update" />
            </Button>
          </Box>
          &nbsp;
          <Paper className="paper-table my-4">
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table className="fee-table" aria-label="sticky table">
                <TableHead
                  className={
                    !isUserAuthorizedToEdit ? 'disable-table-bank' : bankEntity?.commission ? 'disable-table-bank' : 'enhanced-table-bank'
                  }
                  id="feeTable"
                >
                  <TableRow>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.from" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.to" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.feeType" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.amount" />
                    </StyledTableCell>
                    <StyledTableCell
                      hidden={
                        account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                        !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
                      }
                    />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredComexBankFeeList &&
                    filteredComexBankFeeList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((comexBankFee, i) => (
                      <TableRow key={`entity-${i}`}>
                        {i === 0 ? (
                          <StyledTableCell>1&nbsp;</StyledTableCell>
                        ) : (
                          <StyledTableCell>{(groupedData[i - 1]?.fromTo + 1).toLocaleString()}</StyledTableCell>
                        )}
                        <StyledTableCell>{comexBankFee?.fromTo?.toLocaleString()}</StyledTableCell>
                        <StyledTableCell>{comexBankFee?.feeType}</StyledTableCell>
                        <StyledTableCell>
                          {comexBankFee?.feeType === 'Percentage'
                            ? comexBankFee?.amount?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 4 }) + '%'
                            : comexBankFee?.amount?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 4 }) +
                              ' ' +
                              findCurrencyName(comexBankFee?.currencyId)}
                        </StyledTableCell>
                        <StyledTableCell
                          hidden={
                            account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                            !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
                          }
                        >
                          <div className="btn-group flex-btn-group-container" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Tooltip title={translate('comexApp.bank.details.table.editIcon')}>
                              <span>
                                <IconButton
                                  className="px-4"
                                  aria-label="edit"
                                  size="small"
                                  onClick={() => handleClickOpen(comexBankFee?.id, comexBankFee?.fromTo)}
                                  value={comexBankFee?.id}
                                  disabled={!updateCommission || !isUserAuthorizedToEdit}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title={translate('comexApp.bank.details.table.deleteIcon')}>
                              <span>
                                <IconButton
                                  className="px-4"
                                  aria-label="delete"
                                  size="small"
                                  color="error"
                                  onClick={() => setOpenDelete(comexBankFee?.id)}
                                  disabled={!updateCommission || !isUserAuthorizedToEdit}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </div>
                        </StyledTableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              className={Storage.session.get('locale') === 'en' ? 'table-pagination' : 'table-pagination-arabic'}
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredComexBankFeeList?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={translate('home.table.rowsPerPage')}
            />
          </Paper>
          <Typography variant="body2" className="mt-2 mb-3">
            <Translate contentKey="comexApp.bank.details.table.feeDetail" />
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              color="primary"
              disabled={!updateCommission || !isUserAuthorizedToEdit}
              onClick={() => handleClickOpen(0, 0)}
              value={0}
              hidden={
                account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) && !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
              }
            >
              <FontAwesomeIcon icon="plus" /> <Translate contentKey="comexApp.bank.details.table.addFeeBtn" />
            </Button>
          </Box>
        </Collapse>
      </div>
    );
  };

  const renderCommissionAndFeeSectionLocal = () => {
    return (
      <div className="collapse-section">
        <Grid container className="align-items-center">
          <Grid item xs={10} sm={11} md={11.5}>
            <Typography variant="h5" component="div" data-cy="bankFeeHeading">
              {translate('comexApp.bank.details.commissionAndFee')}
            </Typography>
          </Grid>
          <Grid item xs={2} sm={1} md={0.5}>
            <IconButton aria-label="collapse" onClick={handleFeeCollapse}>
              {!feeCollapse ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
            </IconButton>
          </Grid>
        </Grid>
        <Collapse in={!feeCollapse}>
          <br />
          <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <div>
              <FormControl sx={{ width: { md: 300, xs: 280 }, display: 'flex', justifyContent: 'flex-start' }}>
                <Input type="select" width={'80%'} onChange={handleChangeCurrencyDropdownLocal} value={selectedCurrencyLocal}>
                  {availableCurrencyLocal?.map((c, index) => {
                    return (
                      <option key={index} value={c?.id}>
                        {c?.name}
                      </option>
                    );
                  })}
                </Input>
              </FormControl>
            </div>
          </Box>
          <Paper className="paper-table my-4">
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table className="fee-table" aria-label="sticky table">
                <TableHead
                  className={
                    !isUserAuthorizedToEdit
                      ? 'disable-table-bank'
                      : bankEntity?.commissionLocal
                      ? 'enhanced-table-bank'
                      : 'disable-table-bank'
                  }
                  id="commissionTable"
                >
                  <TableRow>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.active" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.commissionForEachAmount" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.commissionAmount" />
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredComexBankCommissionListLocal &&
                    filteredComexBankCommissionListLocal.map((item, i) => (
                      <TableRow key={item.id}>
                        <StyledTableCell>
                          <Checkbox
                            size="small"
                            checked={commissionDataLocal}
                            onChange={handleCommissionLocal}
                            disabled={!isUserAuthorizedToEdit}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          {item?.fromTo?.toLocaleString()}
                          {/* <Input */}
                          {/*   id="commissionForEach" */}
                          {/*   type="text" */}
                          {/*   value={commissionForEachAmt} */}
                          {/*   onChange={handleCommissionForEachAmount} */}
                          {/*   disabled={updateCommissionLocal} */}
                          {/*   autoFocus={isCommissionForEachFieldClicked} */}
                          {/*   /> */}
                        </StyledTableCell>

                        <StyledTableCell>
                          {item?.amount?.toLocaleString() + ' ' + findCurrencyNameLocal(item?.currencyId)}
                          {/* {commissionAmt} */}
                          {/* <Input */}
                          {/*   id="commissionAmount" */}
                          {/*   type="text" */}
                          {/*   value={commissionAmt} */}
                          {/*   onChange={handleCommissionAmount} */}
                          {/*   disabled={updateCommissionLocal} */}
                          {/*   autoFocus={isCommissionAmountFieldClicked} */}
                          {/*   /> */}
                        </StyledTableCell>
                        <StyledTableCell
                          hidden={
                            account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                            !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
                          }
                        >
                          <div className="btn-group flex-btn-group-container" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Tooltip title={translate('comexApp.bank.details.table.editIcon')}>
                              <span>
                                <IconButton
                                  className="px-4"
                                  aria-label="edit"
                                  size="small"
                                  onClick={() => handleClickOpenCommissionLocal(item?.id)}
                                  value={item?.id}
                                  disabled={updatingBank || updateCommissionLocal || !isUserAuthorizedToEdit}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title={translate('comexApp.bank.details.table.deleteIcon')}>
                              <span>
                                <IconButton
                                  className="px-4"
                                  aria-label="delete"
                                  size="small"
                                  color="error"
                                  onClick={() => setOpenDelete(item.id)}
                                  disabled={updatingBank || updateCommissionLocal || !isUserAuthorizedToEdit}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </div>
                        </StyledTableCell>
                        {/* <StyledTableCell> */}
                        {/*   <Button onClick={updateCommissionBank} color="primary" type="button" disabled={updatingBank || updateCommissionLocal}> */}
                        {/*     <Translate contentKey='comexApp.bank.details.update' /> */}
                        {/*   </Button> */}
                        {/* </StyledTableCell> */}
                      </TableRow>
                    ))}
                  {filteredComexBankCommissionListLocal?.length === 0 && (
                    <TableRow>
                      <StyledTableCell>
                        <Checkbox size="small" checked={commissionDataLocal} onChange={handleCommissionLocal} />
                      </StyledTableCell>
                      <StyledTableCell>0</StyledTableCell>
                      <StyledTableCell>0</StyledTableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              color="primary"
              disabled={
                updatingBank || updateCommissionLocal || filteredComexBankCommissionListLocal.length !== 0 || !isUserAuthorizedToEdit
              }
              onClick={() => handleClickOpenCommissionLocal(0)}
              value={0}
              hidden={
                account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) && !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
              }
            >
              <FontAwesomeIcon icon="plus" /> <Translate contentKey="comexApp.bank.details.update" />
            </Button>
          </Box>
          &nbsp;
          <Paper className="paper-table my-4">
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table className="fee-table" aria-label="sticky table">
                <TableHead
                  className={
                    !isUserAuthorizedToEdit
                      ? 'disable-table-bank'
                      : bankEntity?.commissionLocal
                      ? 'disable-table-bank'
                      : 'enhanced-table-bank'
                  }
                  id="feeTable"
                >
                  <TableRow>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.from" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.to" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.feeType" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Translate contentKey="comexApp.bank.details.table.amount" />
                    </StyledTableCell>
                    <StyledTableCell
                      hidden={
                        account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                        !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
                      }
                    />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredComexBankFeeListLocal &&
                    filteredComexBankFeeListLocal.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((comexBankFee, i) => (
                      <TableRow key={`entity-${i}`}>
                        {i === 0 ? (
                          <StyledTableCell>1&nbsp;</StyledTableCell>
                        ) : (
                          <StyledTableCell>{(groupedDataLocal[i - 1]?.fromTo + 1).toLocaleString()}</StyledTableCell>
                        )}
                        <StyledTableCell>{comexBankFee?.fromTo?.toLocaleString()}</StyledTableCell>
                        <StyledTableCell>{comexBankFee?.feeType}</StyledTableCell>
                        <StyledTableCell>
                          {comexBankFee?.feeType === 'Percentage'
                            ? comexBankFee?.amount?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 4 }) + '%'
                            : comexBankFee?.amount?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 4 }) +
                              ' ' +
                              findCurrencyNameLocal(comexBankFee?.currencyId)}
                        </StyledTableCell>
                        <StyledTableCell
                          hidden={
                            account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                            !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
                          }
                        >
                          <div className="btn-group flex-btn-group-container" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Tooltip title={translate('comexApp.bank.details.table.editIcon')}>
                              <span>
                                <IconButton
                                  className="px-4"
                                  aria-label="edit"
                                  size="small"
                                  onClick={() => handleClickOpenLocal(comexBankFee?.id, comexBankFee?.fromTo)}
                                  value={comexBankFee?.id}
                                  disabled={!updateCommissionLocal || !isUserAuthorizedToEdit}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title={translate('comexApp.bank.details.table.deleteIcon')}>
                              <span>
                                <IconButton
                                  className="px-4"
                                  aria-label="delete"
                                  size="small"
                                  color="error"
                                  onClick={() => setOpenDelete(comexBankFee?.id)}
                                  disabled={!updateCommissionLocal || !isUserAuthorizedToEdit}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </div>
                        </StyledTableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              className={Storage.session.get('locale') === 'en' ? 'table-pagination' : 'table-pagination-arabic'}
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredComexBankFeeListLocal?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={translate('home.table.rowsPerPage')}
            />
          </Paper>
          <Typography variant="body2" className="mt-2 mb-3">
            <Translate contentKey="comexApp.bank.details.table.feeDetail" />
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              color="primary"
              disabled={!updateCommissionLocal || !isUserAuthorizedToEdit}
              onClick={() => handleClickOpenLocal(0, 0)}
              value={0}
              hidden={
                account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) && !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
              }
            >
              <FontAwesomeIcon icon="plus" /> <Translate contentKey="comexApp.bank.details.table.addFeeBtn" />
            </Button>
          </Box>
        </Collapse>
      </div>
    );
  };

  // Rebate Fee ranges must mirror the Transaction Fee table above (read-only there),
  // so derive the same from/to boundaries shown in that table's rows. amountsByCurrency comes from
  // the full per-currency group (not the currently-selected-currency-filtered list), since the Rebate
  // Fee section has its own, independent currency selector.
  const amountsByCurrencyForFromTo = (group: { fromTo: number; fee?: { amount?: number; currencyId?: number | null }[] }) => {
    const amountsByCurrency: Record<string, number> = {};
    (group?.fee || []).forEach(f => {
      const key = f?.currencyId === null || f?.currencyId === undefined ? REBATE_PERCENT_KEY : String(f.currencyId);
      amountsByCurrency[key] = Number(f?.amount) || 0;
    });
    return amountsByCurrency;
  };

  const rebateFeeRangesInternational = useMemo(() => {
    return (filteredComexBankFeeList || []).map((fee, i) => {
      const group = groupedData?.find(g => g?.fromTo === fee?.fromTo);
      return {
        id: fee?.id,
        from: i === 0 ? 1 : (groupedData[i - 1]?.fromTo ?? 0) + 1,
        to: fee?.fromTo,
        feeType: fee?.feeType,
        amountsByCurrency: group ? amountsByCurrencyForFromTo(group) : undefined,
      };
    });
  }, [filteredComexBankFeeList, groupedData]);

  const rebateFeeRangesLocal = useMemo(() => {
    return (filteredComexBankFeeListLocal || []).map((fee, i) => {
      const group = groupedDataLocal?.find(g => g?.fromTo === fee?.fromTo);
      return {
        id: fee?.id,
        from: i === 0 ? 1 : (groupedDataLocal[i - 1]?.fromTo ?? 0) + 1,
        to: fee?.fromTo,
        feeType: fee?.feeType,
        amountsByCurrency: group ? amountsByCurrencyForFromTo(group) : undefined,
      };
    });
  }, [filteredComexBankFeeListLocal, groupedDataLocal]);

  // When a bank uses a flat commission instead of ranges (bank.commission / bank.commissionLocal),
  // the Rebate Fee section's flat bucket still needs a real from_to to persist against — use the
  // comex_bank_fee row whose fee_type is 'commission' (fromTo is the same across every currency
  // there, so any one row's value works). comexBankFeeList only ever holds the active tab's rows.
  const commissionFromTo = useMemo(() => {
    const entry = comexBankFeeList?.find(f => f?.feeType === 'commission');
    return entry?.fromTo !== undefined && entry?.fromTo !== null ? Number(entry.fromTo) : undefined;
  }, [comexBankFeeList]);

  // The commission row's own amount, per currency — what the flat bucket's Lump Sum target follows
  // (read-only), same as a range's target follows its own comex_bank_fee amount.
  const commissionAmountsByCurrency = useMemo(() => {
    const amounts: Record<string, number> = {};
    (comexBankFeeList || []).forEach(f => {
      if (f?.feeType === 'commission' && f?.currencyId !== null && f?.currencyId !== undefined) {
        amounts[String(f.currencyId)] = Number(f.amount) || 0;
      }
    });
    return amounts;
  }, [comexBankFeeList]);

  const LocalSections = () => {
    return (
      <>
        <BankGeneralSettingLocal bankId={Number(props.match.params.id)} />
        {renderCommissionAndFeeSectionLocal()}
        <RebateFeeSetting
          bankId={Number(props.match.params.id)}
          bankName={bankEntity?.name}
          commodityType="Local"
          useCommission={commissionDataLocal}
          feeRanges={rebateFeeRangesLocal}
          commissionFromTo={commissionFromTo}
          commissionAmountsByCurrency={commissionAmountsByCurrency}
          transactionCurrencyId={selectedCurrencyLocal}
          availableCurrencies={availableCurrencyLocal}
        />
        <DocumentProvider commodityType="Local" />
        <QuotationSetting />
        <DocumentSetting />
        <PostPurchaseSetting />
        <BookingConfirmationEmailSetting bankId={Number(props.match.params.id)} />
      </>
    );
  };

  const InternationalSections = () => {
    return (
      <>
        <BankGeneralSettingInternational bankId={Number(props.match.params.id)} />
        {renderCommissionAndFeeSectionInternational()}
        <RebateFeeSetting
          bankId={Number(props.match.params.id)}
          bankName={bankEntity?.name}
          commodityType="International"
          useCommission={commissionData}
          feeRanges={rebateFeeRangesInternational}
          commissionFromTo={commissionFromTo}
          commissionAmountsByCurrency={commissionAmountsByCurrency}
          transactionCurrencyId={selectedCurrency}
          availableCurrencies={availableCurrency}
        />
        <DocumentProvider commodityType="International" />
      </>
    );
  };

  return (
    <Container>
      <ThemeProvider theme={responsiveFont}>
        <div className="bank-details-heading-section mt-4">
          <Row>
            <Col sm="8" xs={12}>
              <div className="mb-4">
                <Typography variant="h4" component="div" data-cy="bankDetailPageHeading" className="mb-4">
                  {bankEntity?.name}
                </Typography>

                <Typography component="div" data-cy="bankStartDate" className='"mb-4'>
                  {translate('comexApp.bank.details.startDate')}: {formatDate(bankEntity?.createdDate)}
                </Typography>

                <Typography variant="h6" component="div" data-cy="bankDetailPageHeading" className="mb-4">
                  {bankEntity?.description}
                </Typography>
              </div>
              <Button
                onClick={handleEditBank}
                color="primary"
                hidden={
                  account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) && !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
                }
                disabled={!isUserAuthorizedToEdit}
              >
                <FontAwesomeIcon icon="pencil-alt" />
                <Translate contentKey="comexApp.bank.details.editBtn" />
              </Button>
            </Col>
            <Col sm="4" xs={12}>
              <Box sx={{ justifyContent: { sm: 'flex-end' } }} className="bank-img-box">
                {bankLogo()}
              </Box>
            </Col>
          </Row>
        </div>
        &nbsp; &nbsp;
        <div className="bank-tab-section mb-4">
          <Box sx={{ backgroundColor: '#fafafa', borderRadius: 2, padding: 3 }}>
            <Tabs value={tabIndex} onChange={handleTabChange} aria-label="bank detail tabs" textColor="primary" indicatorColor="primary">
              <Tab label="International" sx={{ fontWeight: tabIndex === 0 ? 'bold' : 'normal' }} />
              <Tab label="Local" sx={{ fontWeight: tabIndex === 1 ? 'bold' : 'normal' }} />
            </Tabs>

            <Box sx={{ marginTop: 2 }}>
              {tabIndex === 0 && <InternationalSections />}
              {tabIndex === 1 && <LocalSections />}
            </Box>
          </Box>
        </div>

        {/* CANCELLATION CONFIGURATION — universal for both Local and International */}
        <CancellationSetting />

        {/* CUSTOMER LOGIN CONFIGURATION — universal for both Local and International */}
        <CustomerLoginSetting />

        {/* DELETE COMMISSION AND FEE DIALOG */}
        {openDelete && <BankDetailFeeDeleteDialog id={openDelete} showModal={openDelete} closeModal={setOpenDelete} tabIndex={tabIndex} />}
        {/* INTERNATIONAL COMMISSION DIALOG */}
        <BankDetailCommissionDialog
          open={internationalCommissionDialog.open}
          isNew={internationalCommissionDialog.isNew}
          eachAmountValue={internationalCommissionDialog.eachAmountValue}
          noDecimalAllowed={internationalCommissionDialog.noDecimalAllowed}
          loading={loading}
          updating={updating}
          feeForm={feeAllCurrencyForm()}
          onClose={handleClose}
          onSubmit={updateNewCommissionBank}
          onEachAmountChange={handleEachAmountValueInternational}
          commodityType="International"
        />
        {/* INTERNATIONAL FEE DIALOG */}
        <BankDetailFeeDialog
          open={internationalFeeDialog.open}
          isNew={internationalFeeDialog.isNew}
          fromValue={internationalFeeDialog.fromValue}
          toValue={internationalFeeDialog.toValue}
          checkedToValue={internationalFeeDialog.checkedToValue}
          noDecimalAllowed={internationalFeeDialog.noDecimalAllowed}
          selectedFeeType={internationalFeeDialog.selectedFeeType}
          validateFromTo={internationalFeeDialog.validateFromTo}
          transactionAmountLimit={bankEntity?.transactionAmountLimit || 99999999999999}
          loading={loading}
          updating={updating}
          uniqueFromAmountFee={uniqueFromAmountFee}
          feeForm={feeAmountFieldInternational()}
          onClose={handleClose}
          onSubmit={saveEntity}
          onFromValueChange={handleFromToValidate}
          onToValueChange={handleToValue}
          onFeeTypeChange={handleFeeTypeChangeInternational}
          onFormStateChange={handleChangeFeeAllCurrency}
          commodityType="International"
        />
        {/* LOCAL COMMISSION DIALOG */}
        <BankDetailCommissionDialog
          open={localCommissionDialog.open}
          isNew={localCommissionDialog.isNew}
          eachAmountValue={localCommissionDialog.eachAmountValue}
          noDecimalAllowed={localCommissionDialog.noDecimalAllowed}
          loading={loading}
          updating={updating}
          feeForm={feeAllCurrencyFormLocal()}
          onClose={handleCloseLocal}
          onSubmit={updateNewCommissionBankLocal}
          onEachAmountChange={handleEachAmountValueLocal}
          commodityType="Local"
        />
        {/* LOCAL FEE DIALOG */}
        <BankDetailFeeDialog
          open={localFeeDialog.open}
          isNew={localFeeDialog.isNew}
          fromValue={localFeeDialog.fromValue}
          toValue={localFeeDialog.toValue}
          checkedToValue={localFeeDialog.checkedToValue}
          noDecimalAllowed={localFeeDialog.noDecimalAllowed}
          selectedFeeType={localFeeDialog.selectedFeeType}
          validateFromTo={localFeeDialog.validateFromTo}
          transactionAmountLimit={bankEntity?.transactionAmountLimit || 99999999999999}
          loading={loading}
          updating={updating}
          uniqueFromAmountFee={uniqueFromAmountFeeLocal}
          feeForm={feeAmountFieldLocal()}
          onClose={handleCloseLocal}
          onSubmit={saveEntityLocal}
          onFromValueChange={handleFromToValidateLocal}
          onToValueChange={handleToValueLocal}
          onFeeTypeChange={handleFeeTypeChangeLocal}
          onFormStateChange={handleChangeFeeAllCurrencyLocal}
          commodityType="Local"
        />
        <Dialog
          open={openBranchEdit}
          onClose={handleEditBranchClose}
          maxWidth={maxWidth}
          fullWidth={fullWidth}
          sx={Storage.session.get('locale') === 'ar-ly' ? { marginLeft: '40px' } : null}
        >
          <DialogTitle style={{ fontWeight: 'bold' }}>
            <Translate contentKey={'comexApp.bank.details.branch.branchName'} />
          </DialogTitle>
          <DialogContent>
            <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton
                aria-label="close"
                onClick={handleEditBranchClose}
                sx={{
                  position: 'absolute',
                  top: 10,
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            {openBranchEdit && (
              <Form onSubmit={handleBranchUpdate}>
                <ValidatedField
                  name="name"
                  id="branchName"
                  validate={{
                    required: { value: true, message: translate('entity.validation.required') },
                    validate: v =>
                      branchList.find(branch => branch?.name?.toLowerCase() === v.toLowerCase()) === undefined ||
                      translate('entity.validation.branchNameAlreadyExists'),
                  }}
                  value={branchName}
                  onChange={e => {
                    setBranchName(e.target.value);
                  }}
                />
                <DialogActions className="mx-3 mb-3">
                  <Button className="flex-end" onClick={handleEditBranchClose}>
                    <Translate contentKey="comexApp.bank.details.cancel" />
                  </Button>
                  <Button
                    className="flex-end"
                    color="primary"
                    type="submit"
                    style={Storage.session.get('locale') === 'en' ? { marginLeft: '10px' } : { marginRight: '10px' }}
                    disabled={updating}
                  >
                    <Translate contentKey="comexApp.bank.details.save" />
                  </Button>
                </DialogActions>
              </Form>
            )}
          </DialogContent>
        </Dialog>
        <Dialog
          open={openBranchCreate}
          onClose={handleCreateBranchClose}
          maxWidth={maxWidth}
          fullWidth={fullWidth}
          sx={Storage.session.get('locale') === 'ar-ly' ? { marginLeft: '40px' } : null}
        >
          <DialogTitle style={{ fontWeight: 'bold' }}>
            {' '}
            <Grid container spacing={2}>
              <Grid item xs={10} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                <Translate contentKey={'comexApp.bank.details.branch.createNewBranch'} />
              </Grid>
            </Grid>
          </DialogTitle>
          <form>
            <DialogContent>
              <DialogContentText component={'span'}>
                <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <IconButton
                    aria-label="close"
                    onClick={handleCreateBranchClose}
                    sx={{
                      position: 'absolute',
                      top: 10,
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Grid>

                <ValidatedField
                  label={translate('comexApp.branch.name')}
                  id="branch-name"
                  name="name"
                  data-cy="name"
                  type="text"
                  register={register}
                  value={branchNameInput}
                  onChange={e => setBranchNameInput(e.target.value)}
                  invalid={isBranchEmpty}
                  validate={{
                    required: { value: true, message: translate('entity.validation.required') },
                  }}
                />
                <Label
                  hidden={!isBranchEmpty}
                  style={{
                    color: 'red',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {translate('entity.validation.required')}
                </Label>
                <Label
                  hidden={!isBranchExists}
                  style={{
                    color: 'red',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {translate('entity.validation.branchNameAlreadyExists')}
                </Label>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="mx-3 mb-3">
              <Button onClick={handleCreateBranchClose}>
                <Translate contentKey="comexApp.bank.details.cancel" />
              </Button>
              <Button
                onClick={() => handleCreateBranch(branchNameInput)}
                color="primary"
                type="button"
                style={Storage.session.get('locale') === 'en' ? { marginLeft: '10px' } : { marginRight: '10px' }}
                disabled={updating}
              >
                <Translate contentKey="comexApp.bank.details.save" />
              </Button>
            </DialogActions>
          </form>
        </Dialog>
        <div className="collapse-section">
          <Grid container className="align-items-center">
            <Grid item xs={10} sm={11} md={11.5}>
              <Typography variant="h5" component="div" data-cy="bankFeeHeading">
                {translate('comexApp.bank.details.reportSettings.title')}
              </Typography>
            </Grid>
            <Grid item xs={2} sm={1} md={0.5}>
              <IconButton aria-label="collapse" onClick={handleReportCollapse}>
                {reportCollapse ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
              </IconButton>
            </Grid>
          </Grid>
          <Collapse in={reportCollapse}>
            <TableContainer className="my-3" sx={{ maxHeight: 320 }}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell style={{ borderBottom: 'none' }}>
                      <Grid container sx={{ alignItems: 'center' }}>
                        <Grid item sm={10} md={10}>
                          <Typography
                            variant="body1"
                            component="div"
                            style={{ fontWeight: 700 }}
                            align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                          >
                            {translate('comexApp.bank.details.reportSettings.bankStaff.title')}
                          </Typography>
                          <Typography
                            variant="body2"
                            component="div"
                            width="65%"
                            align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                          >
                            {translate('comexApp.bank.details.reportSettings.bankStaff.desc')}
                          </Typography>
                        </Grid>
                        <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
                          <Tooltip
                            title={
                              bankEntity?.reportForBankStaff
                                ? translate('comexApp.bank.details.reportSettings.available')
                                : translate('comexApp.bank.details.reportSettings.unavailable')
                            }
                          >
                            <Switch
                              checked={bankEntity?.reportForBankStaff ? reportSwitchState.available : reportSwitchState.unavailable}
                              onChange={handleBankStaffReport}
                              name="reportForBankStaff"
                              disabled={
                                (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                  !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
                                !isUserAuthorizedToEdit
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ borderBottom: 'none' }}>
                      <Grid container sx={{ alignItems: 'center' }}>
                        <Grid item sm={10} md={10}>
                          <Typography
                            variant="body1"
                            component="div"
                            style={{ fontWeight: 700 }}
                            align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                          >
                            {translate('comexApp.bank.details.reportSettings.branchManager.title')}
                          </Typography>
                          <Typography
                            variant="body2"
                            component="div"
                            width="65%"
                            align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                          >
                            {translate('comexApp.bank.details.reportSettings.branchManager.desc')}
                          </Typography>
                        </Grid>
                        <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
                          <Tooltip
                            title={
                              bankEntity?.reportForBranchManager
                                ? translate('comexApp.bank.details.reportSettings.available')
                                : translate('comexApp.bank.details.reportSettings.unavailable')
                            }
                          >
                            <Switch
                              checked={bankEntity?.reportForBranchManager ? reportSwitchState.available : reportSwitchState.unavailable}
                              onChange={handleBranchManagerReport}
                              name="reportForBranchManager"
                              disabled={
                                (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                  !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
                                !isUserAuthorizedToEdit
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ borderBottom: 'none' }}>
                      <Grid container sx={{ alignItems: 'center' }}>
                        <Grid item sm={10} md={10}>
                          <Typography
                            variant="body1"
                            component="div"
                            style={{ fontWeight: 700 }}
                            align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                          >
                            {translate('comexApp.bank.details.reportSettings.areaManager.title')}
                          </Typography>
                          <Typography
                            variant="body2"
                            component="div"
                            width="65%"
                            align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                          >
                            {translate('comexApp.bank.details.reportSettings.areaManager.desc')}
                          </Typography>
                        </Grid>
                        <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
                          <Tooltip
                            title={
                              bankEntity?.reportForAreaManager
                                ? translate('comexApp.bank.details.reportSettings.available')
                                : translate('comexApp.bank.details.reportSettings.unavailable')
                            }
                          >
                            <Switch
                              checked={bankEntity?.reportForAreaManager ? reportSwitchState.available : reportSwitchState.unavailable}
                              onChange={handleAreaManagerReport}
                              name="reportForAreaManager"
                              disabled={
                                (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                  !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
                                !isUserAuthorizedToEdit
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ borderBottom: 'none' }}>
                      <Grid container sx={{ alignItems: 'center' }}>
                        <Grid item sm={10} md={10}>
                          <Typography
                            variant="body1"
                            component="div"
                            style={{ fontWeight: 700 }}
                            align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                          >
                            {translate('comexApp.bank.details.reportSettings.bankManager.title')}
                          </Typography>
                          <Typography
                            variant="body2"
                            component="div"
                            width="65%"
                            align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                          >
                            {translate('comexApp.bank.details.reportSettings.bankManager.desc')}
                          </Typography>
                        </Grid>
                        <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
                          <Tooltip
                            title={
                              bankEntity?.reportForBankManager
                                ? translate('comexApp.bank.details.reportSettings.available')
                                : translate('comexApp.bank.details.reportSettings.unavailable')
                            }
                          >
                            <Switch
                              checked={bankEntity?.reportForBankManager ? reportSwitchState.available : reportSwitchState.unavailable}
                              onChange={handleBankManagerReport}
                              name="reportForBankManager"
                              disabled={
                                (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                  !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
                                !isUserAuthorizedToEdit
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ borderBottom: 'none' }}>
                      <Grid container sx={{ alignItems: 'center' }}>
                        <Grid item sm={10} md={10}>
                          <Typography
                            variant="body1"
                            component="div"
                            style={{ fontWeight: 700 }}
                            align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                          >
                            {translate('comexApp.bank.details.reportSettings.auditor.title')}
                          </Typography>
                          <Typography
                            variant="body2"
                            component="div"
                            width="65%"
                            align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                          >
                            {translate('comexApp.bank.details.reportSettings.auditor.desc')}
                          </Typography>
                        </Grid>
                        <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
                          <Tooltip
                            title={
                              bankEntity?.reportForAuditor
                                ? translate('comexApp.bank.details.reportSettings.available')
                                : translate('comexApp.bank.details.reportSettings.unavailable')
                            }
                          >
                            <Switch
                              checked={bankEntity?.reportForAuditor ? reportSwitchState.available : reportSwitchState.unavailable}
                              onChange={handleAuditorReport}
                              name="reportForAuditor"
                              disabled={
                                (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                  !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
                                !isUserAuthorizedToEdit
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Collapse>
        </div>
        <div className="collapse-section">
          <Grid container className="align-items-center">
            <Grid item xs={10} sm={11} md={11.5}>
              <Typography variant="h5" component="div" data-cy="bankFeeHeading">
                {translate('comexApp.bank.details.apiSettings.title')}
              </Typography>
            </Grid>
            <Grid item xs={2} sm={1} md={0.5}>
              <IconButton aria-label="collapse" onClick={handleApiSettingsCollapse}>
                {apiSettingsCollapse ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
              </IconButton>
            </Grid>
          </Grid>
          <Collapse in={apiSettingsCollapse}>
            <br />
            <ValidatedField
              label={translate('comexApp.bank.details.apiSettings.sellConfirmationEndpoint')}
              id="sell-confirmation-endpoint"
              name="sellConfirmationEndpoint"
              data-cy="sellConfirmationEndpoint"
              type="text"
              value={valueSellConfirmationEndpoint}
              onChange={handleValueSellConfirmationEndpoint}
              disabled={!isUserAuthorizedToEdit}
            />

            <Grid container spacing={2}>
              <Grid item md={6} sm={6} xs={5}>
                <ValidatedField
                  label={translate('comexApp.bank.details.apiSettings.vendorName')}
                  id="vendor-name"
                  name="vendorName"
                  data-cy="vendorName"
                  type="text"
                  value={valueVendorName}
                  onChange={handleValueVendorName}
                  disabled={!isUserAuthorizedToEdit}
                />
              </Grid>
              <Grid item md={6} sm={6} xs={7}>
                <ValidatedField
                  label={translate('comexApp.bank.details.apiSettings.vendorCif')}
                  id="vendorCif"
                  name="vendorCif"
                  data-cy="vendorCif"
                  type="text"
                  value={valueVendorCif}
                  onChange={handleValueVendorCif}
                  onInput={e => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/\D/g, '');
                  }}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  disabled={!isUserAuthorizedToEdit}
                />
              </Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                color="primary"
                onClick={handleApiSettings}
                value={0}
                hidden={
                  account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) && !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)
                }
                disabled={!isUserAuthorizedToEdit}
              >
                <FontAwesomeIcon icon="plus" /> <Translate contentKey="comexApp.bank.details.update" />
              </Button>
            </Box>
          </Collapse>
        </div>

        <div className="branch-select-section">
          <Typography variant="h5" component="div" data-cy="branchSectionHeading" className="mb-4">
            {translate('comexApp.bank.details.branch.title')}
          </Typography>
          <Row className="mt-4">
            <Col sm={6} xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                <div>
                  <FormControl sx={{ width: { md: 300, xs: 280 }, display: 'flex', justifyContent: 'flex-start' }}>
                    <Input type="select" width={'80%'} defaultValue="" onChange={handleChange}>
                      <option value="" label={translate('comexApp.bank.details.branch.selectPlaceholder')} disabled={true}></option>
                      {branchList.map(branch => {
                        if (branch?.bank?.name === bankEntity?.name) {
                          // getAreaManager(branch)
                          return (
                            <option key={branch?.id} value={`${branch?.name}|${branch?.id}|${branch?.areaManagerId}`}>
                              {branch?.name}
                            </option>
                          );
                        }
                        return null;
                      })}
                    </Input>
                  </FormControl>
                </div>
              </Box>
            </Col>
            <Col sm={6} xs={12}>
              <Box sx={{ display: 'flex', justifyContent: { sm: 'flex-end' }, mt: { xs: '10%', sm: 0 } }}>
                <Button
                  color="primary"
                  hidden={
                    account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                    !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)
                  }
                  onClick={() => {
                    setOpenBranchCreate(true);
                  }}
                  disabled={!isUserAuthorizedToEdit}
                >
                  <FontAwesomeIcon icon="plus" /> <Translate contentKey="comexApp.bank.details.branch.addBtn" />
                </Button>
              </Box>
            </Col>
          </Row>
        </div>
        {active ? (
          <div className="branch-section">
            <div style={{ flexDirection: 'row', alignItems: 'center' }}>
              <div style={{ display: 'inline-flex' }}>
                <h2 data-cy="bankDetailsHeading">{branchValue}&nbsp;(Branch)</h2>
              </div>
              <div style={{ display: 'inline-flex', marginRight: '12px', marginLeft: '12px' }}>
                <Tooltip
                  title={translate('comexApp.bank.details.editBranchBtn')}
                  hidden={
                    account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                    !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)
                  }
                >
                  <IconButton
                    aria-label="edit"
                    size="small"
                    onClick={() => {
                      setOpenBranchEdit(true);
                    }}
                    disabled={!isUserAuthorizedToEdit}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
              <div>
                <p>
                  {translate('comexApp.bank.details.startDate')} : {formatDate(selectedBranchEntity?.createdDate)}{' '}
                </p>
              </div>
            </div>
            {/* <Row>*/}
            {/*  <Grid container>*/}
            {/*    <Grid item xs={12}>*/}
            {/*      <Box sx={{ display: 'inline-flex', width: '100%' }}>*/}
            {/*        <ListItem disablePadding>*/}
            {/*          /!* {accountsByBranchId && selectedBranchEntity && accountsByBranchId.map((user, i) => { *!/*/}
            {/*          /!*   if (areaManager?.authorities[0] === 'ROLE_AREA_MANAGER' && areaManager.id===selectedBranchEntity.areaManagerId) { *!/*/}
            {/*          /!*     return ( *!/*/}
            {/*          {areaManager && areaManagerId !== 'null' &&*/}
            {/*            <ListItemButton component="a" onClick={() => props.history.push(`/admin/user-management/${areaManager?.login}`)}*/}
            {/*              id={areaManager?.login} key={`user`} style={{ paddingLeft: '0px' }}>*/}
            {/*              <ListItemAvatar>*/}
            {/*                <Avatar className={classes.avatar}>*/}
            {/*                  {areaManager?.firstName?.charAt(0)}*/}
            {/*                  {areaManager?.lastName?.charAt(0)}*/}
            {/*                </Avatar>*/}
            {/*              </ListItemAvatar>*/}
            {/*              <ListItemText id="Name"*/}
            {/*                sx={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}>*/}
            {/*                <Typography variant='body1'>*/}
            {/*                  {areaManager?.firstName}&nbsp;{areaManager?.lastName}*/}
            {/*                  &nbsp;*/}
            {/*                  <span className='text-secondary'>(Area Manager)</span>*/}
            {/*                </Typography>*/}
            {/*              </ListItemText>*/}
            {/*            </ListItemButton>*/}
            {/*          }*/}
            {/*          /!*     )} *!/*/}
            {/*          /!* {accountsByBranchId && selectedBranchEntity && accountsByBranchId.map((user, i) => { *!/*/}
            {/*          /!*   if (areaManager?.authorities[0] === 'ROLE_AREA_MANAGER' && areaManager.id===selectedBranchEntity.areaManagerId) { *!/*/}
            {/*          /!*     return ( *!/*/}
            {/*          {areaManager && areaManagerId !== 'null' &&*/}
            {/*            <ListItemButton component="a" onClick={() => props.history.push(`/admin/user-management/${areaManager?.login}`)}*/}
            {/*              id={areaManager?.login} key={`user`} style={{ paddingLeft: '0px' }}>*/}
            {/*              <ListItemAvatar>*/}
            {/*                <Avatar className={classes.avatar}>*/}
            {/*                  {areaManager?.firstName?.charAt(0)}*/}
            {/*                  {areaManager?.lastName?.charAt(0)}*/}
            {/*                </Avatar>*/}
            {/*              </ListItemAvatar>*/}
            {/*              <ListItemText id="Name"*/}
            {/*                sx={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}>*/}
            {/*                <Typography variant='body1'>*/}
            {/*                  {areaManager?.firstName}&nbsp;{areaManager?.lastName}*/}
            {/*                  &nbsp;*/}
            {/*                  <span className='text-secondary'>(Area Manager)</span>*/}
            {/*                </Typography>*/}
            {/*              </ListItemText>*/}
            {/*            </ListItemButton>*/}
            {/*          }*/}
            {/*          /!*     )} *!/*/}
            {/*          /!* })} *!/*/}
            {/*        </ListItem>*/}
            {/*      </Box>*/}
            {/*    </Grid>*/}
            {/*  </Grid>*/}
            {/* </Row>*/}

            <Box sx={{ mt: 4, mb: 4 }}>
              <BranchSettingsWrapper
                account={account}
                branchEntity={selectedBranchEntity}
                isUserAuthorizedToEdit={isUserAuthorizedToEdit}
              />
            </Box>

            <Box className="area-manager-name" sx={{ display: 'flex', alignItems: 'center' }}>
              <Box
                sx={{
                  width: 12,
                  height: 32,
                  mr: 2,
                  backgroundColor: 'primary.dark',
                  '&:hover': {
                    backgroundColor: 'primary.main',
                    opacity: [0.9, 0.8, 0.7],
                  },
                }}
              />
              <Typography variant="h6" className="mt-2 mb-1" fontWeight="bold">
                <Translate contentKey="comexApp.bank.areaManager" />
              </Typography>
            </Box>
            <Paper sx={{ width: '100%', overflow: 'hidden', mt: 2, mb: 8 }}>
              <List
                sx={{
                  position: 'relative',
                  overflow: 'auto',
                  maxHeight: 300,
                  '& ul': { padding: 0 },
                }}
              >
                {accountsUser &&
                  areaManagerId &&
                  accountsUser?.map((user, i) => {
                    const isAreaManager = user?.authorities.includes('ROLE_AREA_MANAGER');
                    if (isAreaManager && user?.id === +areaManagerId) {
                      return (
                        <li key={`user-${i}`}>
                          <ul>
                            <ListItemButton
                              component="a"
                              onClick={() => props.history.push(`/admin/user-management/${user?.login}`)}
                              id={user?.login}
                              style={{ paddingLeft: '10px' }}
                            >
                              <Grid container spacing={2}>
                                <Grid item md={8} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                  <ListItemAvatar sx={{ minWidth: { xs: '3px', md: '56px' }, marginRight: { xs: '10px', md: '0px' } }}>
                                    <Avatar className={classes.avatar}>
                                      {user?.firstName?.charAt(0)}
                                      {user?.lastName?.charAt(0)}
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText id="Name" sx={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}>
                                    {user?.firstName}&nbsp;{user?.lastName}
                                  </ListItemText>
                                </Grid>
                                <Grid item md={4} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                  <ListItemAvatar sx={{ minWidth: { xs: '3px', md: '56px' }, marginRight: { xs: '10px', md: '0px' } }}>
                                    <EmailIcon color="disabled" />
                                  </ListItemAvatar>
                                  <ListItemText id="Email" sx={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}>
                                    {user?.email}
                                  </ListItemText>
                                </Grid>
                              </Grid>
                            </ListItemButton>
                          </ul>
                        </li>
                      );
                    }
                  })}
              </List>
            </Paper>

            {branchList?.map(branch => {
              if (branch?.name === branchValue) {
                return (
                  <React.Fragment key={branch?.id}>
                    <Row className="branch-approval">
                      <Col sm="6">
                        <div className="purchase-section" style={{ backgroundColor: `${branch.managerApproval ? '#0f3e58' : '#959595'}` }}>
                          <Grid container spacing={2}>
                            <Grid item md={1} xs={2}>
                              <Box className="mt-2">
                                <VerticalAlignBottomIcon sx={{ transform: 'rotate(90deg)' }} />
                              </Box>
                            </Grid>
                            <Grid item xs={8}>
                              <Typography variant="body1" className="my-2" fontWeight="bold" color="#FFFFFF">
                                <Translate contentKey="comexApp.bank.details.branch.managerApproval" />
                              </Typography>
                              <Typography variant="caption" className="mb-3">
                                <Translate contentKey="comexApp.bank.details.branch.managerApprovalDetail" />
                              </Typography>
                            </Grid>
                            <Grid item md={3} xs={2}>
                              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                {branch.managerApproval ? (
                                  <Tooltip title={translate('comexApp.bank.details.switch.required')}>
                                    <Switch
                                      aria-label="required"
                                      color="info"
                                      edge="end"
                                      checked={branch.managerApproval ? switchState.required : switchState.notRequired}
                                      onChange={handleSwitchManager(branch)}
                                      name="managerApproval"
                                      disabled={
                                        (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                          !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
                                        !isUserAuthorizedToEdit
                                      }
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title={translate('comexApp.bank.details.switch.notRequired')}>
                                    <Switch
                                      aria-label="notRequired"
                                      color="info"
                                      edge="end"
                                      checked={branch.managerApproval ? switchState.required : switchState.notRequired}
                                      onChange={handleSwitchManager(branch)}
                                      name="managerApproval"
                                      disabled={
                                        (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                          !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
                                        !isUserAuthorizedToEdit
                                      }
                                    />
                                  </Tooltip>
                                )}
                              </Box>
                            </Grid>
                            <Grid item md={1} xs={2}>
                              <Box className="mt-2">
                                <AccessAlarmsIcon />
                              </Box>
                            </Grid>
                            <Grid item xs={8}>
                              <Typography variant="caption" className="mb-3">
                                <Translate
                                  contentKey="comexApp.bank.details.branch.escalateApprovalDetail"
                                  interpolate={{ approvalTimePeriod: approvalTime }}
                                />
                              </Typography>
                            </Grid>
                            <Grid item md={3} xs={2}>
                              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                {branch.escalateApproval ? (
                                  <Tooltip title={translate('comexApp.bank.details.switch.required')}>
                                    <Switch
                                      aria-label="required"
                                      color="info"
                                      edge="end"
                                      checked={branch.escalateApproval ? switchState.required : switchState.notRequired}
                                      onChange={handleSwitchEscalate(branch)}
                                      name="managerApproval"
                                      disabled={
                                        (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                          !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
                                        !isUserAuthorizedToEdit
                                      }
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title={translate('comexApp.bank.details.switch.notRequired')}>
                                    <Switch
                                      aria-label="notRequired"
                                      color="info"
                                      edge="end"
                                      checked={branch.escalateApproval ? switchState.required : switchState.notRequired}
                                      onChange={handleSwitchEscalate(branch)}
                                      name="managerApproval"
                                      disabled={
                                        (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                          !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
                                        !isUserAuthorizedToEdit
                                      }
                                    />
                                  </Tooltip>
                                )}
                              </Box>
                            </Grid>
                          </Grid>
                        </div>
                      </Col>
                      <Col sm="6">
                        <div
                          className="transfer-section mt-4 mt-sm-0"
                          style={{ backgroundColor: `${branch.customerApproval ? '#5BA7BF' : '#959595'}` }}
                        >
                          <Grid container spacing={2}>
                            <Grid item md={1} xs={2}>
                              <Box className="mt-2">
                                <SwapHorizIcon />
                              </Box>
                            </Grid>
                            <Grid item xs={8}>
                              <Typography variant="body1" className="my-2" fontWeight="bold" color="#FFFFFF">
                                <Translate contentKey="comexApp.bank.details.branch.customerApproval" />
                              </Typography>
                              <Typography variant="caption" className="mb-4">
                                <Translate contentKey="comexApp.bank.details.branch.customerApprovalDetail" />
                              </Typography>
                            </Grid>
                            <Grid item md={3} xs={2}>
                              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                {branch.customerApproval ? (
                                  <Tooltip title={translate('comexApp.bank.details.switch.required')}>
                                    <Switch
                                      aria-label="required"
                                      color="primary"
                                      edge="end"
                                      checked={branch.customerApproval ? switchState.required : switchState.notRequired}
                                      onChange={handleSwitchCustomer(branch)}
                                      name="customerApproval"
                                      disabled={
                                        (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                          !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
                                        !isUserAuthorizedToEdit
                                      }
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title={translate('comexApp.bank.details.switch.notRequired')}>
                                    <Switch
                                      aria-label="notRequired"
                                      color="primary"
                                      edge="end"
                                      checked={branch.customerApproval ? switchState.required : switchState.notRequired}
                                      onChange={handleSwitchCustomer(branch)}
                                      name="customerApproval"
                                      disabled={
                                        (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                          !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
                                        !isUserAuthorizedToEdit
                                      }
                                    />
                                  </Tooltip>
                                )}
                              </Box>
                            </Grid>
                          </Grid>
                        </div>
                      </Col>
                    </Row>

                    {/* Bank Staff Transaction Section */}
                    <Row className="bank-staff-transaction">
                      <Col sm="6">
                        <div
                          className="bank-staff-section mt-4 mt-sm-0"
                          style={{
                            backgroundColor: `${
                              branch.sellApprovalInternationalCommodity || branch.sellApprovalLocalCommodity ? '#4A90A4' : '#959595'
                            }`,
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid item md={1} xs={2}>
                              <Box className="mt-2">
                                <SwapHorizIcon />
                              </Box>
                            </Grid>
                            <Grid item xs={10} md={11}>
                              <Typography variant="body1" className="my-2" fontWeight="bold" color="#FFFFFF">
                                <Translate contentKey="comexApp.bank.details.branch.allowBankStaffToSellTransaction" />
                              </Typography>

                              {/* International Commodity Row */}
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                                <Typography variant="body2" color="#FFFFFF">
                                  <Translate contentKey="comexApp.bank.details.branch.internationalCommodity" />
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {branch.sellApprovalInternationalCommodity ? (
                                    <Tooltip title={translate('comexApp.bank.details.switch.required')}>
                                      <Switch
                                        aria-label="required"
                                        color="primary"
                                        edge="end"
                                        checked={branch.sellApprovalInternationalCommodity ? switchState.required : switchState.notRequired}
                                        onChange={handleSwitchAllowToSellInternationalCommodity(branch)}
                                        name="internationalCommodity"
                                        disabled={
                                          (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                            !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
                                          !isUserAuthorizedToEdit
                                        }
                                      />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title={translate('comexApp.bank.details.switch.notRequired')}>
                                      <Switch
                                        aria-label="notRequired"
                                        color="primary"
                                        edge="end"
                                        checked={branch.sellApprovalInternationalCommodity ? switchState.required : switchState.notRequired}
                                        onChange={handleSwitchAllowToSellInternationalCommodity(branch)}
                                        name="internationalCommodity"
                                        disabled={
                                          (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                            !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
                                          !isUserAuthorizedToEdit
                                        }
                                      />
                                    </Tooltip>
                                  )}
                                </Box>
                              </Box>

                              {/* Local Commodity Row */}
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                                <Typography variant="body2" color="#FFFFFF">
                                  <Translate contentKey="comexApp.bank.details.branch.localCommodity" />
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {branch.sellApprovalLocalCommodity ? (
                                    <Tooltip title={translate('comexApp.bank.details.switch.required')}>
                                      <Switch
                                        aria-label="required"
                                        color="primary"
                                        edge="end"
                                        checked={branch.sellApprovalLocalCommodity ? switchState.required : switchState.notRequired}
                                        onChange={handleSwitchAllowToSellLocalCommodity(branch)}
                                        name="localCommodity"
                                        disabled={
                                          (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                            !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
                                          !isUserAuthorizedToEdit
                                        }
                                      />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title={translate('comexApp.bank.details.switch.notRequired')}>
                                      <Switch
                                        aria-label="notRequired"
                                        color="primary"
                                        edge="end"
                                        checked={branch.sellApprovalLocalCommodity ? switchState.required : switchState.notRequired}
                                        onChange={handleSwitchAllowToSellLocalCommodity(branch)}
                                        name="localCommodity"
                                        disabled={
                                          (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                                            !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
                                          !isUserAuthorizedToEdit
                                        }
                                      />
                                    </Tooltip>
                                  )}
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>
                        </div>
                      </Col>
                    </Row>
                  </React.Fragment>
                );
              }
              return null;
            })}

            <Box className="branch-manager-name" sx={{ display: 'flex', alignItems: 'center' }}>
              <Box
                sx={{
                  width: 12,
                  height: 32,
                  mr: 2,
                  backgroundColor: 'primary.dark',
                  '&:hover': {
                    backgroundColor: 'primary.main',
                    opacity: [0.9, 0.8, 0.7],
                  },
                }}
              />
              <Typography variant="h6" className="mt-2 mb-1" fontWeight="bold">
                <Translate contentKey="comexApp.bank.details.branchManager" />
              </Typography>
            </Box>
            <Paper sx={{ width: '100%', overflow: 'hidden', mt: 2, mb: 8 }}>
              <List
                sx={{
                  position: 'relative',
                  overflow: 'auto',
                  maxHeight: 300,
                  '& ul': { padding: 0 },
                }}
              >
                {accountsByBranchId &&
                  accountsByBranchId?.map((user, i) => {
                    // Check if the user's authorities include 'ROLE_BRANCH_MANAGER'
                    const isBranchManager = user?.authorities.includes('ROLE_BRANCH_MANAGER');
                    if (isBranchManager) {
                      return (
                        <li key={`user-${i}`}>
                          <ul>
                            <ListItemButton
                              component="a"
                              onClick={() => props.history.push(`/admin/user-management/${user.login}`)}
                              id={user.login}
                              style={{ paddingLeft: '10px' }}
                            >
                              <Grid container spacing={2}>
                                <Grid item md={8} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                  <ListItemAvatar sx={{ minWidth: { xs: '3px', md: '56px' }, marginRight: { xs: '10px', md: '0px' } }}>
                                    <Avatar className={classes.avatar}>
                                      {user?.firstName?.charAt(0)}
                                      {user?.lastName?.charAt(0)}
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText id="Name" sx={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}>
                                    {user?.firstName}&nbsp;{user?.lastName}
                                  </ListItemText>
                                </Grid>
                                <Grid item md={4} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                  <ListItemAvatar sx={{ minWidth: { xs: '3px', md: '56px' }, marginRight: { xs: '10px', md: '0px' } }}>
                                    <EmailIcon color="disabled" />
                                  </ListItemAvatar>
                                  <ListItemText id="Email" sx={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}>
                                    {user?.email}
                                  </ListItemText>
                                </Grid>
                              </Grid>
                            </ListItemButton>
                          </ul>
                        </li>
                      );
                    }
                  })}
              </List>
            </Paper>
            <Box className="staff-name" sx={{ display: 'flex', alignItems: 'center' }}>
              <Box
                sx={{
                  width: 12,
                  height: 32,
                  mr: 2,
                  backgroundColor: 'primary.dark',
                  '&:hover': {
                    backgroundColor: 'primary.main',
                    opacity: [0.9, 0.8, 0.7],
                  },
                }}
              />
              <Typography variant="h6" className="mt-2 mb-1" fontWeight="bold">
                <Translate contentKey="comexApp.bank.details.staff" />
              </Typography>
            </Box>
            <Paper sx={{ width: '100%', overflow: 'hidden', mt: 2, mb: 8 }}>
              <List
                sx={{
                  position: 'relative',
                  overflow: 'auto',
                  maxHeight: 300,
                  '& ul': { padding: 0 },
                }}
              >
                {accountsByBranchId?.map((user, i) => {
                  if (user?.authorities[0] === 'ROLE_BANK_STAFF') {
                    return (
                      <li key={`user-${i}`}>
                        <ul>
                          <ListItemButton
                            component="a"
                            onClick={() => props.history.push(`/admin/user-management/${user.login}`)}
                            id={user.login}
                            style={{ paddingLeft: '10px' }}
                          >
                            <Grid container spacing={2}>
                              <Grid item md={8} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                <ListItemAvatar sx={{ minWidth: { xs: '3px', md: '56px' }, marginRight: { xs: '10px', md: '0px' } }}>
                                  <Avatar className={classes.avatar}>
                                    {user?.firstName?.charAt(0)}
                                    {user?.lastName?.charAt(0)}
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText id="Name" sx={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}>
                                  {user?.firstName}&nbsp;{user?.lastName}
                                </ListItemText>
                              </Grid>
                              <Grid item md={4} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                <ListItemAvatar sx={{ minWidth: { xs: '3px', md: '56px' }, marginRight: { xs: '10px', md: '0px' } }}>
                                  <EmailIcon color="disabled" />
                                </ListItemAvatar>
                                <ListItemText id="Email" sx={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right' }}>
                                  {user?.email}
                                </ListItemText>
                              </Grid>
                            </Grid>
                          </ListItemButton>
                        </ul>
                      </li>
                    );
                  }
                })}
              </List>
            </Paper>
          </div>
        ) : (
          <Typography variant="body2" color="disabled">
            <Translate contentKey="comexApp.bank.details.notActive" />
          </Typography>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }} className="back-button mt-4">
          <Button
            tag={Link}
            to="/bank"
            data-cy="entityDetailsBackButton"
            onClick={() => {
              window.localStorage.removeItem('selectedBranch');
              localStorage.removeItem('feeAmount');
            }}
          >
            <FontAwesomeIcon icon="arrow-left" /> <Translate contentKey="entity.action.back">Back</Translate>
          </Button>
        </Box>
      </ThemeProvider>
    </Container>
  );
};

export default BankDetail;
